import React, { useState, useEffect, useRef } from 'react';
import { FaStar, FaChevronDown, FaChevronUp, FaWhatsapp, FaPhoneAlt, FaComment } from 'react-icons/fa';
import api from './api';
import useAuth from "../hooks/useAuth";
import { canDo, isSuper } from '../utils/canDo';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './TherapistDashboard.css';

import { useNavigate } from "react-router-dom";
import MiniCalendarWithBlocks from './MiniCalendarWithBlocks';
import EscalationModal from './EscalationModal';
import { useDialog } from './useDialog';
import AppointmentCallModal from './AppointmentCallModal';

const POLL_INTERVAL = 300000; // 300 seconds (5 min) — real-time session sync now via socket

const TherapistDashboard = () => {
  const [appointments, setAppointments] = useState([]);
  const [tomappointments, setTomAppts] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [checklists, setChecklists] = useState([]);
  const [missedChecklists, setMissedChecklists] = useState([]);
  const [missedCLSearch, setMissedCLSearch] = useState('');
  const [clBusy, setClBusy] = useState({});  // { [itemId]: true } — prevents double-click
  const [allappointments, setAllAppointments] = useState([]);
  const [flowTasks, setFlowTasks] = useState([]);
  const [showFlowTasks, setShowFlowTasks] = useState(true);
  const [pendingBookings, setPendingBookings]         = useState([]);
  const [showPendingBookings, setShowPendingBookings] = useState(true);
  const [pendingApprovals, setPendingApprovals]       = useState([]);
  const [showPendingApprovals, setShowPendingApprovals] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showOTT, setShowOTT] = useState(false);
  const [showCheck, setShowCheck] = useState(false);
  const [showAppt, setShowAppt] = useState(true);
  const [showAllAppts, setShowAllAppts] = useState(false);
  const [inventoryShortage, setInventoryShortage] = useState([]);
  // Modal state
  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [showInvModal, setShowInventoryModal] = useState(false);
  const [selectedAppt, setSelectedAppt] = useState(null);
  const [detailAppt, setDetailAppt] = useState(null);     // appointment detail modal
  const [detailTask, setDetailTask] = useState(null);      // OTT task detail modal
  const [callModal, setCallModal] = useState(null);        // AppointmentCallModal state
  const [futureDate, setFutureDate] = useState(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [schedulePlannedDuration, setSchedulePlannedDuration] = useState(50); // minutes
  const [isOnlineSchedule, setIsOnlineSchedule] = useState(false);
   const [extendedForms, setExtendedForms] = useState({});
  const [reorderFields, setReorderFields] = useState({});
  const [reorderQtys, setReorderQtys] = useState({});
  const [tentativeDates, setTentativeDates] = useState({});
  const [issued, setIssued] = useState([]);
  const [showIssuedModal, setShowIssuedModal] = useState(false);
const [showCommentModal, setShowCommentModal] = useState(false);
const [selectedReasons, setSelectedReasons] = useState([]);
const [commentText, setCommentText] = useState('');

// Session complete modal (Completed? button after 6PM)
const [showSessionCompleteModal, setShowSessionCompleteModal] = useState(false);
const [sessionCompleteAppt, setSessionCompleteAppt] = useState(null);
const [scLeadTherapist, setScLeadTherapist] = useState("selectT");
const [scLeadTherapistDesignation, setScLeadTherapistDesignation] = useState("");
const [scHelper1, setScHelper1] = useState("selectT");
const [scHelper2, setScHelper2] = useState("selectT");
const [scComment, setScComment] = useState("");
const [scTherapists, setScTherapists] = useState([]);
const [showEscalationInComplete, setShowEscalationInComplete] = useState(false);
const [showStandaloneEscalation, setShowStandaloneEscalation] = useState(false);
const [scActualStartTime, setScActualStartTime] = useState('');
const [scActualEndTime, setScActualEndTime] = useState('');
const [scExerciseBulkStatus, setScExerciseBulkStatus] = useState('');
const [scPatientExercises, setScPatientExercises] = useState([]);

  // Missing-geo branches warning (owner/solution only)
  const [missingGeoBranches, setMissingGeoBranches] = useState([]);

  // User selector (admin/owner/solution can view other users)
  const [allStaff, setAllStaff] = useState([]);
  const [viewUser, setViewUser] = useState('');       // '' = self (default)
  const [showUserPicker, setShowUserPicker] = useState(false);

  const pollTimeout = useRef(null);
  const { auth } = useAuth();
  const navigate = useNavigate();
  const { dialogNode, showAlert, showConfirm } = useDialog();

  const canViewOthers = canDo(auth, 'dashboard.view_others');
  const activeUser = viewUser || auth.username; // the user whose data is displayed

    // Track which month to display for each checklist
  const [monthOffsets, setMonthOffsets] = React.useState({});

    // 🧭 Utility functions
  const changeMonth = (id, delta) => {
    setMonthOffsets((prev) => ({
      ...prev,
      [id]: (prev[id] ?? 0) + delta,
    }));
  };
  
  const fetchDashboardData = async(targetUser) => {
    const u = targetUser || activeUser;
    setLoading(true);
    try {
    const apptsRes =  await api.get(`${process.env.REACT_APP_URL}/appointments/today/dashboard/Therapy/${u}?_=${new Date().getTime()}`);
    const tomappointments =  await api.get(`${process.env.REACT_APP_URL}/appointments/tomorrow/dashboard/Therapy/${u}?_=${new Date().getTime()}`)
    const tasksRes = await api.get(`${process.env.REACT_APP_URL}/tasks/today/dashboard/Task/${u}?_=${new Date().getTime()}`)
    const checklistsRes = await api.get(`${process.env.REACT_APP_URL}/checklists/dashboard/${u}?_=${new Date().getTime()}`)
    const issued =  await api.get(`${process.env.REACT_APP_URL}/services/issuedInventory/${u}?_=${new Date().getTime()}`)
    try {
      const flowTasksRes = await api.get(`${process.env.REACT_APP_URL}/flows/assigned/${u}`);
      setFlowTasks(flowTasksRes.data || []);
    } catch (e) { setFlowTasks([]); }

    if (canDo(auth, 'appointments.view')) {
      try {
        const pbRes = await api.get(`${process.env.REACT_APP_URL}/appointments/patient-bookings/pending`);
        setPendingBookings(pbRes.data || []);
      } catch (e) { setPendingBookings([]); }
      try {
        const paRes = await api.get(`${process.env.REACT_APP_URL}/patients/consultation/pending-approvals`);
        setPendingApprovals(paRes.data || []);
      } catch (e) { setPendingApprovals([]); }
    }

    let inventoryShortage = [];
    if (canDo(auth, 'inventory.view'))
    {
      inventoryShortage = await api.get(`${process.env.REACT_APP_URL}/services/ReRoot/shortage/6?_=${new Date().getTime()}`)
     setInventoryShortage(inventoryShortage.data);
    }
    // Missing-geo warning for owner/solution
    if (isSuper(auth)) {
      try {
        const geoRes = await api.get(`${process.env.REACT_APP_URL}/branches/missing-geo`);
        setMissingGeoBranches(geoRes.data || []);
      } catch (e) { setMissingGeoBranches([]); }
    }

    //  .then(([apptsRes, tomappointments, tasksRes, leavesRes, inventoryShortage]) => {
        console.log("sorting now --> ", u, apptsRes.data.length);
        
        setAppointments(sortAppointments(apptsRes.data));
        setTomAppts(sortAppointments(tomappointments.data));
        setTasks(tasksRes.data);
        setIssued(issued.data);

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const now = new Date();
        const hour = now.getHours();
        const isAfter2PM = hour >= 14;
        const isAfter11PM = hour >= 23;

        // Look back 7 days for missed recurrences
        const sevenDaysAgo = new Date(today);
        sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);

        const checks = [];
        const missedItems = [];

        checklistsRes.data.forEach((item) => {
          const recurrences = item.recurrences || [];
          const completions = item.completions || [];

          // Find recurrence for today
          const todayRecurrence = recurrences.find(({ date }) => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            return d.getTime() === today.getTime();
          });

          if (todayRecurrence) {
            const completion = completions.find(
              (c) => new Date(c.date).toDateString() === today.toDateString()
            );
            const isCompleted = !!completion;
            const isNA = completion?.notApplicable === true;
            checks.push({
              id: item._id,
              title: item.title,
              description: item.description,
              date: new Date(item.date),
              recurrenceDate: todayRecurrence.date,
              isCompleted,
              isNA,
              isDelayed: !isCompleted && !isNA && isAfter2PM,
              canComplete: !isCompleted && !isNA && !isAfter11PM,
            });
          }

          // Find missed recurrences (past 7 days, no completion, not today)
          recurrences.forEach(({ date }) => {
            const d = new Date(date);
            d.setHours(0, 0, 0, 0);
            if (d >= sevenDaysAgo && d < today) {
              const hasCompletion = completions.some((c) => {
                const cd = new Date(c.date);
                cd.setHours(0, 0, 0, 0);
                return cd.getTime() === d.getTime();
              });
              if (!hasCompletion) {
                missedItems.push({
                  id: item._id,
                  title: item.title,
                  assignee: item.assignee,
                  missedDate: d,
                  daysAgo: Math.floor((today - d) / 86400000),
                });
              }
            }
          });
        });

        setChecklists(checks);
        // Sort missed items chronologically (oldest first)
        missedItems.sort((a, b) => a.missedDate - b.missedDate);
        setMissedChecklists(missedItems);
        
        setLoading(false);



    }
      catch(err) {
        showAlert(`Error: ${err}`, 'error');
        setLoading(false);
      };
  };

  // Lightweight checklist-only refresh (avoids full dashboard reload + 429 errors)
  const refreshChecklistsOnly = async () => {
    const u = viewUser || auth.username;
    try {
      const checklistsRes = await api.get(`${process.env.REACT_APP_URL}/checklists/dashboard/${u}?_=${Date.now()}`);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const now = new Date();
      const isAfter2PM = now.getHours() >= 14;
      const isAfter11PM = now.getHours() >= 23;
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      const checks = [];
      const missedItems = [];
      checklistsRes.data.forEach((item) => {
        const recurrences = item.recurrences || [];
        const completions = item.completions || [];
        const todayRecurrence = recurrences.find(({ date }) => {
          const d = new Date(date); d.setHours(0, 0, 0, 0);
          return d.getTime() === today.getTime();
        });
        if (todayRecurrence) {
          const completion = completions.find(c => new Date(c.date).toDateString() === today.toDateString());
          const isCompleted = !!completion;
          const isNA = completion?.notApplicable === true;
          checks.push({
            id: item._id, title: item.title, description: item.description,
            date: new Date(item.date), recurrenceDate: todayRecurrence.date,
            isCompleted, isNA,
            isDelayed: !isCompleted && !isNA && isAfter2PM,
            canComplete: !isCompleted && !isNA && !isAfter11PM,
          });
        }
        recurrences.forEach(({ date }) => {
          const d = new Date(date); d.setHours(0, 0, 0, 0);
          if (d >= sevenDaysAgo && d < today) {
            const hasCompletion = completions.some(c => { const cd = new Date(c.date); cd.setHours(0, 0, 0, 0); return cd.getTime() === d.getTime(); });
            if (!hasCompletion) missedItems.push({ id: item._id, title: item.title, assignee: item.assignee, missedDate: d, daysAgo: Math.floor((today - d) / 86400000) });
          }
        });
      });
      setChecklists(checks);
      missedItems.sort((a, b) => a.missedDate - b.missedDate);
      setMissedChecklists(missedItems);
    } catch (err) {
      console.error('[refreshChecklistsOnly]', err);
    }
  };

  // Fetch staff list for user picker (admin/owner/solution only)
  useEffect(() => {
    if (canViewOthers) {
      api.get(`${process.env.REACT_APP_URL}/users/staff/all`)
        .then(res => setAllStaff((res.data || []).filter(u => u.username)))
        .catch(() => {});
    }
  }, []);

  // Fetch dashboard data on mount and on viewUser change
  useEffect(() => {
    const u = viewUser || auth.username;
    fetchDashboardData(u);
    clearInterval(pollTimeout.current);
    pollTimeout.current = setInterval(() => fetchDashboardData(u), POLL_INTERVAL);
    return () => clearInterval(pollTimeout.current);
  }, [viewUser]);


  const sortAppointments = (appts) => {
    console.log("sortAppts =", appts);
  
    return appts
        .slice() // copy so you don't mutate state
        .sort((a, b) => {
        const dateA = new Date(a.start || a.date);
        const dateB = new Date(b.start || b.date);
        return dateA - dateB; // ascending: earliest → latest
        });
    };


  // Appointment Status Checks
  const now = new Date();

const getAppointmentStatusFlags = (appt) => {
  const start = new Date(appt.start || appt.date);
  const end = new Date(appt.end || appt.date);
  const status = appt.status?.toLowerCase() || "";

  const diffMs = start - now;
  const oneHour = 60 * 60 * 1000;

  const isUpcoming = diffMs > 0 && diffMs <= oneHour && status === "scheduled";
  const isLate = now >= start && now <= end && status === "scheduled";
  const isMissed = now > end && !["completed", "inprogress"].includes(status);
  const isOngoing = status === "inprogress";
  // Mutual exclusivity
  return {
    isUpcoming,
    isLate: !isUpcoming && isLate,
    isMissed: !isUpcoming && !isLate && isMissed,
    isOngoing
  };
};

function calculateTaskStars(task, today = new Date()) {
  const estimated = task.estimatedEndDate ? new Date(task.estimatedEndDate) : null;
  const final = task.finalEndDate ? new Date(task.finalEndDate) : null;
  const status = task.status;
  const taskCreated = task.createdAt;

  let redStars = 0;
  let blueStars = 0;
  let needsUserAction = false;
  let updatedStatus = status;

  if (!estimated) {
    return { redStars, blueStars, needsUserAction, updatedStatus };
  }

  
  // Case 2: Pending/Delayed, estimated passed, no finalEndDate
  if ((status === "new") && today > taskCreated) {
    updatedStatus = "pending";
  }
  
  // Case 1: Completed before or on estimatedEndDate
  if (status === "completed" && today <= estimated) {
    if (task.frequency == "OneTime")    
      blueStars = task.totalWorth;    
    else 
      blueStars = 1;
    redStars = 0;
  }

  // Case 2: Pending/Delayed, estimated passed, no finalEndDate
  else if ((status === "pending" || status === "delayed") && today > estimated && !final) {
    redStars = 1;
    blueStars = 0;
    needsUserAction = true;
    updatedStatus = "delayed";
  }

  // Case 3: Completed after estimatedEndDate
  else if (status === "completed" && final && final > estimated) {
    redStars = task.merit?.redStars || 1;
    blueStars = 0;
  }

  // Case 4: Still delayed even after finalEndDate
  else if (status === "delayed" && final && final > estimated) {
    const overdueDays = Math.ceil((final - estimated) / (1000 * 60 * 60 * 24));
    redStars = Math.min(overdueDays, 5);
    blueStars = 0;
  }

  return { redStars, blueStars, needsUserAction, updatedStatus };
}

// Simplified WhatsApp sender
const sendWhatsAppMsg = async (to, message) => {
  try {
    // Open WhatsApp Web with pre-filled message
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${to}?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank"); // Open WhatsApp Web
    console.log(`WhatsApp message window opened for ${to}`);
  } catch (err) {
    console.error("Error opening WhatsApp message:", err);
  }
};

  const openScheduleModal = async (appt) => {
    console.log("open ", appt);
    setSelectedAppt(appt);
    setFutureDate(new Date(appt.start || appt.date));
    // Calculate planned duration from exercises
    try {
      const res = await api.get(`${process.env.REACT_APP_URL}/patients/consultation/patientsequences/${appt.patientCard}?t=${Date.now()}`);
      const seqs = res.data?.sequences || [];
      const mins = seqs.reduce((sum, ex) => sum + (ex.duration ?? 1) * (ex.repetition ?? 1), 0) || 50;
      setSchedulePlannedDuration(mins);
    } catch (e) {
      setSchedulePlannedDuration(50);
    }
    setShowScheduleModal(true);
  };

  const closeModal = () => {
    setShowScheduleModal(false);
    setFutureDate(null);
    setSelectedAppt(null);
  };

  const openShowModal = (appt, whose) => {
    if (whose == "patient")
    {
      console.log("open ", appt.patientCard);
      fetchAllAppts(whose, appt.patientCard);
      setSelectedAppt(appt);
    }
    else {
      fetchAllAppts(whose, auth.username);
      setSelectedAppt(null);
    }
     setShowAllAppts(true);
  };

  const closeShowModal = () => {
    setShowAllAppts(false);
    setSelectedAppt(null);
  };

  // 6PM IST check
  const isAfter2PMIST = () => {
    const nowIST = new Date(new Date().getTime() + 5.5 * 60 * 60 * 1000);
    return nowIST.getUTCHours() >= 14;
  };

  const toDatetimeLocal = (d) => {
    const dt = d ? new Date(d) : new Date();
    if (isNaN(dt)) return '';
    const pad = n => String(n).padStart(2, '0');
    return `${dt.getFullYear()}-${pad(dt.getMonth()+1)}-${pad(dt.getDate())}T${pad(dt.getHours())}:${pad(dt.getMinutes())}`;
  };

  const fetchTherapistsForModal = () => {
    api.get(`${process.env.REACT_APP_URL}/users/sessionstaff/therapist`)
      .then(res => setScTherapists(res.data || []))
      .catch(err => console.error('Error fetching therapists', err));
  };

  const fetchPatientExercises = (patientCard) => {
    api.get(`${process.env.REACT_APP_URL}/patients/consultation/${patientCard}`)
      .then(res => setScPatientExercises(res.data?.sequences || []))
      .catch(() => setScPatientExercises([]));
  };

  const handleSessionComplete = async (status = 'Completed') => {
    if (!scLeadTherapist || scLeadTherapist === 'selectT') {
      alert('Please select the Lead Therapist');
      return;
    }
    const appt = sessionCompleteAppt;
    const isScheduled = appt.status?.toLowerCase() === 'scheduled';

    // Bulk-mark remaining exercises if therapist chose to
    if (scExerciseBulkStatus && scPatientExercises.length > 0) {
      const updatedExers = scPatientExercises.map(seq => {
        if (['notStarted', 'Pending', 'OnGoing'].includes(seq.status)) {
          return { ...seq, status: scExerciseBulkStatus, pendingreps: 0 };
        }
        return seq;
      });
      try {
        await api.post(
          `${process.env.REACT_APP_URL}/patients/consultation/patientsequences/updateremaining/${appt.patientCard}/${scExerciseBulkStatus}`,
          { reorderedExers: updatedExers }
        );
      } catch (e) {
        console.error('Error bulk-updating exercises:', e);
      }
    }

    const payload = {
      status,
      sessionComment: scComment.trim(),
      sessionComments: scComment.trim(),
      leadTherapist: scLeadTherapist,
      leadTherapistDesignation: scLeadTherapistDesignation,
      helperTherapist1: scHelper1 !== 'selectT' ? scHelper1 : '',
      helperTherapist2: scHelper2 !== 'selectT' ? scHelper2 : '',
      ...(scActualEndTime && { actualEndTime: scActualEndTime }),
      ...(isScheduled && scActualStartTime && { actualStartTime: scActualStartTime }),
    };
    try {
      // Try full session-done flow (billing + patient update)
      await api.post(
        `${process.env.REACT_APP_URL}/patients/consultation/patientsequences/sessiondone/${appt.patientCard}/${appt._id}`,
        payload
      );
      setShowSessionCompleteModal(false);
      setShowEscalationInComplete(false);
      fetchDashboardData();
      openScheduleModal(appt);
    } catch (err) {
      console.error('sessiondone failed, falling back to update:', err);
      // Fallback: update appointment directly
      try {
        await api.post(`${process.env.REACT_APP_URL}/appointments/update/${appt._id}`, payload);
        setShowSessionCompleteModal(false);
        setShowEscalationInComplete(false);
        fetchDashboardData();
        openScheduleModal(appt);
      } catch (err2) {
        console.error(err2);
        alert('Error saving session: ' + (err2.response?.data || err2.message));
      }
    }
  };

    // --- Mark Recurrence Done (updates row in-place, no full page reload) ---
  const handleRecurrenceTick = async (item, date, checked) => {
    try {
      if (!checked) return;
      if (clBusy[item.id]) return; // prevent double-click
      if (!(await showConfirm("Are you sure, you want to mark this done ?"))) return;

      setClBusy(prev => ({ ...prev, [item.id]: true }));
      const todayMidnight = new Date();
      todayMidnight.setHours(0, 0, 0, 0);
      const isLate = date < todayMidnight;

      // Optimistically update the row immediately for instant feedback
      setChecklists(prev => prev.map(c =>
        c.id === item.id ? { ...c, isCompleted: true, isDelayed: false, canComplete: false } : c
      ));

      api.patch(`${process.env.REACT_APP_URL}/checklists/${item.id}/complete`,
        { markedBy: auth.username, date, isLate }
      )
      .then(() => {
        showAlert("Marked as completed ✅", 'success');
      })
      .catch((error) => {
        const msg = error?.response?.data?.message || '';
        if (msg.toLowerCase().includes('already')) {
          // Already done on server — row is already green, just notify
          showAlert("Already completed ✅", 'success');
        } else {
          // Real error — revert the optimistic update
          setChecklists(prev => prev.map(c =>
            c.id === item.id ? { ...c, isCompleted: false, isDelayed: false, canComplete: true } : c
          ));
          showAlert(msg || "Something went wrong while completing the checklist", 'error');
        }
      })
      .finally(() => setClBusy(prev => ({ ...prev, [item.id]: false })));
    } catch (err) {
      console.error("❌ Failed to mark recurrence done", err);
      setClBusy(prev => ({ ...prev, [item.id]: false }));
    }
  };

  // --- Mark Recurrence as Not Applicable (updates row in-place) ---
  const handleNotApplicable = async (item, date) => {
    try {
      if (clBusy[item.id]) return; // prevent double-click
      if (!(await showConfirm("Mark this task as Not Applicable for today?"))) return;

      setClBusy(prev => ({ ...prev, [item.id]: true }));
      // Optimistic update
      setChecklists(prev => prev.map(c =>
        c.id === item.id ? { ...c, isNA: true, isCompleted: false, canComplete: false } : c
      ));

      api.patch(`${process.env.REACT_APP_URL}/checklists/${item.id}/not-applicable`,
        { markedBy: auth.username, date }
      )
      .then(() => {
        showAlert("Marked as N/A", 'success');
      })
      .catch((error) => {
        // Revert on error
        setChecklists(prev => prev.map(c =>
          c.id === item.id ? { ...c, isNA: false, canComplete: true } : c
        ));
        showAlert(error?.response?.data?.message || "Failed to mark N/A", 'error');
      })
      .finally(() => setClBusy(prev => ({ ...prev, [item.id]: false })));
    } catch (err) {
      console.error("❌ Failed to mark as N/A", err);
      setClBusy(prev => ({ ...prev, [item.id]: false }));
    }
  };

  // --- Mark Entire Checklist Done ---
  const handleMarkDone = async (item) => {
    try {
      const today = new Date();
      const res = await api.patch(
        `${process.env.REACT_APP_URL}/checklists/${item._id}/complete`,
        { markedBy: auth.username, date: today }
      );
      setChecklists((prev) =>
        prev.map((c) => (c.id === item.id ? res.data : c))
      );
    } catch (err) {
      console.error("❌ Mark done failed", err);
    }
  };

  const handlePlaceOrderClick = (id) => {
    setExtendedForms((prev) => ({ ...prev, [id]: true }));
    setReorderFields((prev) => ({ ...prev, [id]: false }));
  };

  const handleReceivedSupply = (id, name) => {
    alert(`Mark ${name} as received`);
    setExtendedForms((prev) => ({ ...prev, [id]: false }));
  };

  const handleReorder = (id) => {
    setReorderFields((prev) => ({ ...prev, [id]: true }));

    // Tentative receiving date = 10 days from today
    const date = new Date();
    date.setDate(date.getDate() + 10);
    setTentativeDates((prev) => ({ ...prev, [id]: date.toISOString().slice(0, 10) }));
  };

  const handleQtyChange = (id, value) => {
    setReorderQtys((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmitReorder = (id, name) => {
    const qty = reorderQtys[id];
    const date = tentativeDates[id];
    alert(`Reordering ${qty} units of ${name}, tentative date: ${date}`);
    setExtendedForms((prev) => ({ ...prev, [id]: false }));
  };


   const scheduleAppointment = (appt, newStart) => {
    // End time = start + planned exercise duration (or 50 min default)
    const durMin = schedulePlannedDuration > 0 ? schedulePlannedDuration : 50;
    const endDate = new Date(new Date(newStart).getTime() + durMin * 60 * 1000);
    const newAppointment = {
      ...appt,
      start: newStart,
      end: endDate,
      isToday: false,
      handoverTo: appt.username,
      handoverFrom: appt.username,
      date: newStart,
      status: "scheduled",
      isOnline: isOnlineSchedule,
    };

    delete newAppointment._id;
    delete newAppointment.__v;

    api.post(`${process.env.REACT_APP_URL}/appointments/dynamic/add`, newAppointment)
      .then(() => {
        alert("✅ Appointment scheduled!");
        fetchDashboardData();
        closeModal();
   
    
      // Make sure phone number is in correct format
        // Example title: "John Doe / 9876543210"
      const [namePart, numberPart] = (appt.title || "").split("/").map(s => s.trim());

      // Remove all non-digit characters from number
      const phoneNumber = numberPart ? numberPart.replace(/\D/g, "") : "";

      console.log(namePart);    // "John Doe"
      console.log(phoneNumber); // "9876543210"
        // ✅ Auto-generate WhatsApp message
            
      const formatted = new Date(newStart).toLocaleString("en-US", {
        weekday: "short",  // e.g., "Sun"
        year: "numeric",
        month: "short",    // e.g., "Nov"
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true       // 12-hour format
      });

      console.log(formatted);

      const message = `Namaste ${namePart} Ji, your appointment is scheduled on ${formatted}.`;

      if (phoneNumber) sendWhatsAppMsg(phoneNumber, message);
        else showAlert("No phone number provided for WhatsApp message.", 'warning');
      
    })
      .catch((err) => {
        console.error("Error scheduling:", err);
        showAlert(`❌ Error scheduling appointment. ${err}`, 'error');
      });
  };

  const fetchAllAppts = async (whose, pc) => {
    
    try {
    const apptsRes = await api.get(`${process.env.REACT_APP_URL}/appointments/${whose}/${pc}?_=${new Date().getTime()}`);
    
        console.log("sorting now --> ", apptsRes.data.length);
        
        setAllAppointments(apptsRes.data);
    }     
    catch(err) {
        showAlert(`Error loading appointments`, 'error');
    }
  };


const summary = appointments.reduce(
  (acc, appt) => {
    const { isUpcoming, isLate, isMissed, isOngoing } = getAppointmentStatusFlags(appt);
    const status = appt.status?.toLowerCase();

    if (isUpcoming) acc.upcoming++;
    else if (isLate) acc.late++;
    else if (isMissed) acc.missed++;

    if (status === "inprogress") acc.inprogress++;
    if (appt.escalated) acc.escalated++;

    if (
      appt.isToday &&
      ["completed", "skipped", ].includes(status) &&
      appt.hasSessionComment
    ) {
      acc.completedWithComments++;
    }

   if (
      appt.isToday &&
      ["completed", "skipped", "inprogress"].includes(status) &&
      !appt.hasSessionComment
    ) {
      acc.requireComments++;
    }

    return acc;
  },
  {
    upcoming: 0,
    late: 0,
    missed: 0,
    inprogress: 0,
    completedWithComments: 0,
    requireComments: 0,
    redMarks: 0,
    greenStars: 0,
    reviewsCollected: 0,
    escalated: 0,
  }
);

  return (
    <div className="dashboard-container" onClick={() => showUserPicker && setShowUserPicker(false)}>
      {dialogNode}

      {/* Missing branch coordinates warning — owner/solution only */}
      {missingGeoBranches.length > 0 && isSuper(auth) && (
        <div style={{
          background: 'linear-gradient(135deg,#fef3c7,#fde68a)',
          border: '1px solid #f59e0b', borderRadius: 12, padding: '12px 18px',
          marginBottom: 12, fontSize: 13, boxShadow: '0 2px 8px rgba(245,158,11,0.2)',
        }}>
          <strong style={{ color: '#92400e' }}>Branch coordinates missing:</strong>{' '}
          <span style={{ color: '#78350f' }}>
            {missingGeoBranches.map(b => b.name || b.branchId).join(', ')}
          </span>
          <div style={{ fontSize: 11, color: '#a16207', marginTop: 4 }}>
            QR attendance and geo-fencing will not work for these branches until coordinates are configured in Branches.
          </div>
        </div>
      )}

      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10, marginBottom: 4 }}>
        <h2 style={{ margin: 0 }}>{activeUser}'s Dashboard — {new Date().toLocaleDateString("en-GB")}</h2>

        {/* User picker — admin/owner/solution/supervisor only */}
        {canViewOthers && (
          <div style={{ position: 'relative' }}>
            <button
              onClick={() => setShowUserPicker(v => !v)}
              style={{
                padding: '7px 16px', borderRadius: 8,
                border: `1.5px solid ${showUserPicker ? '#3b82f6' : '#cbd5e1'}`,
                background: showUserPicker ? '#eff6ff' : '#f8fafc',
                color: showUserPicker ? '#1d4ed8' : '#334155',
                fontWeight: 600, fontSize: 13, cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 6,
              }}
            >
              👥 {activeUser === auth.username ? 'My Dashboard' : activeUser} ▾
            </button>

            {showUserPicker && (
              <div onClick={e => e.stopPropagation()}
                style={{
                  position: 'absolute', top: '110%', right: 0, zIndex: 999,
                  background: '#fff', borderRadius: 12, boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                  border: '1px solid #e2e8f0', minWidth: 240, maxHeight: 380, overflowY: 'auto',
                  padding: '8px 0',
                }}
              >
                {/* Quick actions */}
                <div style={{ display: 'flex', gap: 6, padding: '6px 12px', borderBottom: '1px solid #f1f5f9', flexWrap: 'wrap' }}>
                  <button onClick={() => { setViewUser(''); setShowUserPicker(false); }}
                    style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #bbf7d0', background: activeUser === auth.username ? '#dcfce7' : '#f0fdf4', color: '#16a34a', fontWeight: 700, cursor: 'pointer' }}>
                    Only Me
                  </button>
                  <button onClick={() => setShowUserPicker(false)}
                    style={{ fontSize: 11, padding: '4px 10px', borderRadius: 6, border: '1px solid #e2e8f0', background: '#f8fafc', color: '#64748b', fontWeight: 600, cursor: 'pointer' }}>
                    Done
                  </button>
                </div>

                {/* Staff list */}
                {allStaff
                  .filter(u => u.status !== 'inactive' && u.status !== 'terminated')
                  .sort((a, b) => a.username.localeCompare(b.username))
                  .map(u => (
                    <div key={u.username}
                      onClick={() => { setViewUser(u.username === auth.username ? '' : u.username); setShowUserPicker(false); }}
                      style={{
                        padding: '7px 14px', cursor: 'pointer', fontSize: 13, fontWeight: 600,
                        display: 'flex', alignItems: 'center', gap: 8,
                        background: (u.username === activeUser) ? '#eff6ff' : 'transparent',
                        color: (u.username === activeUser) ? '#1d4ed8' : '#334155',
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f1f5f9'}
                      onMouseLeave={e => e.currentTarget.style.background = (u.username === activeUser) ? '#eff6ff' : 'transparent'}
                    >
                      <span style={{
                        width: 8, height: 8, borderRadius: '50%',
                        background: (u.username === activeUser) ? '#2563eb' : '#cbd5e1',
                        flexShrink: 0,
                      }} />
                      {u.username}
                      {u.username === auth.username && <span style={{ fontSize: 10, color: '#94a3b8', marginLeft: 'auto' }}>(you)</span>}
                    </div>
                  ))
                }
              </div>
            )}
          </div>
        )}
      </div>

    {/* ── Mobile chip bar (visible on small screens only) ── */}
    <div className="td-mobile-chips">
      {canDo(auth, 'appointments.view') && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#ff8c00,#e65100)' }}
          onClick={() => openShowModal(null, 'therapist')}>
          📅 Schedule
        </button>
      )}
      {summary.escalated > 0 && canDo(auth, 'patients.escalate') && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#dc2626,#b91c1c)' }}
          onClick={() => setShowAppt(true)}>
          🔔 Escalated <span className="td-chip-badge">{summary.escalated}</span>
        </button>
      )}
      {canDo(auth, 'appointments.view') && pendingBookings.length > 0 && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#d97706,#92400e)' }}
          onClick={() => setShowPendingBookings(v => !v)}>
          🟡 Bookings <span className="td-chip-badge">{pendingBookings.length}</span>
        </button>
      )}
      {issued.length > 0 && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#1565c0,#0d47a1)' }}
          onClick={() => setShowIssuedModal(true)}>
          🗂️ Issued <span className="td-chip-badge">{issued.length}</span>
        </button>
      )}
      {tasks.length > 0 && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#e65100,#bf360c)' }}
          onClick={() => { setShowCheck(false); setShowAppt(false); setShowOTT(true); }}>
          🗂️ OTT <span className="td-chip-badge">{tasks.filter(t => t.status !== 'completed').length}</span>
        </button>
      )}
      {checklists.length > 0 && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#2e7d32,#1b5e20)' }}
          onClick={() => { setShowCheck(true); setShowAppt(false); setShowOTT(false); }}>
          ☑️ Checklists <span className="td-chip-badge">{checklists.length}</span>
        </button>
      )}
      {summary.redMarks > 0 && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#b71c1c,#7f0000)' }}>
          ❌ Red <span className="td-chip-badge">{summary.redMarks}</span>
        </button>
      )}
      {summary.greenStars > 0 && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#388e3c,#1b5e20)' }}>
          ✅ Stars <span className="td-chip-badge">{summary.greenStars}</span>
        </button>
      )}
      {canDo(auth, 'inventory.view') && (
        <button className="td-mobile-chip" style={{ background: 'linear-gradient(135deg,#6d4c41,#3e2723)' }}
          onClick={() => setShowInventoryModal(true)}>
          ⚠️ Inventory
        </button>
      )}
    </div>

    {/* Main 2-Column Layout */}
    <div style={{ display: "flex", alignItems: "flex-start", gap: "25px", padding: "20px" }}>
      
      {/* ================= LEFT COLUMN ================= */}     
       {/* Left Column: Summary Cards (50%) */}
        <div style={{ flex: "0 0 70%", maxWidth: "70%" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "10px",
            }}
          >
            {summary.upcoming > 0 && (
            <div className="summary-card upcoming">
              <div className="card-icon">⏰</div>
              <div className="card-count">{summary.upcoming}</div>
              <div className="card-label">Upcoming</div>
            </div>
          )} {summary.late > 0 && (
            <div className="summary-card late">
              <div className="card-icon">🔵</div>
              <div className="card-count">{summary.late}</div>
              <div className="card-label">Running Late</div>
            </div>
          )} {summary.missed > 0 && (
            <div className="summary-card missed">
              <div className="card-icon">❌</div>
              <div className="card-count">{summary.missed}</div>
              <div className="card-label">Missed</div>
            </div>
          )} {summary.inprogress > 0 && (
            <div className="summary-card inprogress">
              <div className="card-icon">✅</div>
              <div className="card-count">{summary.inprogress}</div>
              <div className="card-label">In Progress</div>
            </div>
          )} {summary.completedWithComments > 0 && (
            <div className="summary-card completed">
              <div className="card-icon">💬</div>
              <div className="card-count">{summary.completedWithComments}</div>
              <div className="card-label">Completed</div>
            </div>
          )} {summary.requireComments > 0 && (
            <div className="summary-card missed">
              <div className="card-icon">📝</div>
              <div className="card-count">{summary.requireComments}</div>
              <div className="card-label">Need Comments</div>
            </div>
          )} {canDo(auth, 'inventory.view') && inventoryShortage.length > 0 && (
            <div className="summary-card shortage">
              <div className="card-icon">⚠️</div>
              <div className="card-count">{inventoryShortage.length}</div>
              <div className="card-label">Low Stock</div>
            </div>
          )} {canDo(auth, 'appointments.view') && pendingBookings.length > 0 && (
            <div className="summary-card" style={{ background: 'linear-gradient(135deg,#d97706,#b45309)', border: '1.5px solid #f59e0b', cursor: 'pointer' }}
              onClick={() => setShowPendingBookings(v => !v)}>
              <div className="card-icon">🟡</div>
              <div className="card-count">{pendingBookings.length}</div>
              <div className="card-label">Pending Bookings</div>
            </div>
          )} {canDo(auth, 'appointments.view') && pendingApprovals.length > 0 && (
            <div className="summary-card" style={{ background: 'linear-gradient(135deg,#7c3aed,#5b21b6)', border: '1.5px solid #a78bfa', cursor: 'pointer' }}
              onClick={() => setShowPendingApprovals(v => !v)}>
              <div className="card-icon">📋</div>
              <div className="card-count">{pendingApprovals.length}</div>
              <div className="card-label">Plans for Approval</div>
            </div>
          )} {summary.escalated > 0 && canDo(auth, 'patients.escalate') && (
            <div className="summary-card" style={{ background: 'linear-gradient(135deg,#dc2626,#b91c1c)', border: '2px solid #f87171', cursor: 'pointer', animation: 'pulse 2s infinite' }}
              onClick={() => setShowAppt(true)}>
              <div className="card-icon">🔔</div>
              <div className="card-count">{summary.escalated}</div>
              <div className="card-label">Escalated</div>
            </div>
          )} {issued.length > 0 && (
            <div className="summary-card" style={{ background: 'linear-gradient(135deg,#1565c0,#0d47a1)', border: '1.5px solid #42a5f5', cursor: 'pointer' }}
              onClick={() => setShowIssuedModal(true)}>
              <div className="card-icon">🗂️</div>
              <div className="card-count">{issued.length}</div>
              <div className="card-label">Issued Items</div>
            </div>
          )}

          </div>
           

      {loading && <p>Loading data...</p>}

      {/* Appointments */}
      <section className="appointments-section">
        <div className={`section-title ${showAppt ? 'open' : ''}`} onClick={() => setShowAppt(!showAppt)}>
          <span className="section-label">🧑‍⚕️ Therapy Appointments
            <span style={{ background: '#2196f3', color: '#fff', borderRadius: 20, padding: '1px 10px', fontSize: 12, fontWeight: 700, marginLeft: 8 }}>
              {appointments.length}
            </span>
          </span>
          <span className="section-chevron">{showAppt ? <FaChevronUp /> : <FaChevronDown />}</span>
        </div>

        {showAppt && appointments.length === 0 && !loading && <p>No therapy appointments for today.</p>}
        {showAppt && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 10 }}>
            {appointments.map((appt, idx) => {
              const startDate = new Date(appt.start || appt.date);
              const endDate = new Date(appt.end || appt.date);
              const { isUpcoming, isLate, isMissed } = getAppointmentStatusFlags(appt);
              const isInProgress = appt.status?.toLowerCase() === 'inprogress';
              const patientName = (appt.title || '').split('/')[0]?.trim();
              let cardPhone = '';
              if (appt.title && appt.title.includes('/')) cardPhone = appt.title.split('/')[1]?.trim();

              let borderColor = '#e2e8f0';
              let statusLabel = '';
              let statusColor = '#64748b';
              if (isInProgress) { borderColor = '#22c55e'; statusLabel = 'In Progress'; statusColor = '#16a34a'; }
              else if (isUpcoming) { borderColor = '#f59e0b'; statusLabel = 'Upcoming'; statusColor = '#d97706'; }
              else if (isLate) { borderColor = '#3b82f6'; statusLabel = 'Late'; statusColor = '#2563eb'; }
              else if (isMissed || appt.missedToday) { borderColor = '#ef4444'; statusLabel = 'Missed'; statusColor = '#dc2626'; }
              else if (appt.status?.toLowerCase() === 'completed') { borderColor = '#a78bfa'; statusLabel = 'Done'; statusColor = '#7c3aed'; }

              return (
                <div key={idx}
                  style={{
                    background: '#fff', borderRadius: 12, padding: '12px 14px',
                    borderLeft: `4px solid ${borderColor}`, boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                    transition: 'transform 0.12s, box-shadow 0.12s', position: 'relative',
                    display: 'flex', flexDirection: 'column',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)'; }}
                >
                  {/* Clickable content area — opens detail modal */}
                  <div onClick={() => setDetailAppt(appt)} style={{ cursor: 'pointer', flex: 1 }}>
                    {/* Status chip */}
                    {statusLabel && (
                      <span style={{ position: 'absolute', top: 8, right: 8, fontSize: 9, fontWeight: 700, color: statusColor, background: statusColor + '15', padding: '2px 7px', borderRadius: 6, textTransform: 'uppercase', letterSpacing: '.3px' }}>
                        {statusLabel}
                      </span>
                    )}
                    {/* Patient name */}
                    <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 4, paddingRight: statusLabel ? 60 : 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {patientName}
                    </div>
                    {/* Time */}
                    <div style={{ fontSize: 12, color: '#64748b', fontWeight: 600, marginBottom: 4 }}>
                      {startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} — {endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                    </div>
                    {/* Card ID */}
                    {appt.patientCard && (
                      <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600 }}>{appt.patientCard}</div>
                    )}
                    {/* Anomaly badges */}
                    <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 6 }}>
                      {appt.escalated && <span style={{ fontSize: 9, fontWeight: 700, background: '#fef2f2', color: '#dc2626', padding: '1px 6px', borderRadius: 4 }}>ESCALATED</span>}
                      {appt.missedToday && appt.missedCount > 1 && <span style={{ fontSize: 9, fontWeight: 700, background: '#fef2f2', color: '#dc2626', padding: '1px 6px', borderRadius: 4 }}>Miss x{appt.missedCount}</span>}
                      {appt.autoMarkedDone && <span style={{ fontSize: 9, fontWeight: 700, background: '#fff7ed', color: '#c2410c', padding: '1px 6px', borderRadius: 4 }}>Auto</span>}
                    </div>
                  </div>
                  {/* Quick action buttons — touch-friendly, always visible */}
                  <div style={{ display: 'flex', gap: 10, marginTop: 10, paddingTop: 10, borderTop: '1px solid #f1f5f9', alignItems: 'center', flexWrap: 'wrap' }}>
                    {cardPhone && (
                      <button
                        onClick={e => { e.stopPropagation(); setCallModal({ appt, phone: cardPhone, mode: 'whatsapp' }); }}
                        title="WhatsApp Message"
                        style={{ minWidth: 42, height: 42, borderRadius: 10, background: '#dcfce7', border: '1.5px solid #86efac', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#16a34a', cursor: 'pointer', fontSize: 18 }}>
                        <FaWhatsapp />
                      </button>
                    )}
                    {cardPhone && (
                      <button
                        onClick={e => { e.stopPropagation(); setCallModal({ appt, phone: cardPhone, mode: 'call' }); }}
                        title="WhatsApp Call"
                        style={{ minWidth: 42, height: 42, borderRadius: 10, background: '#dbeafe', border: '1.5px solid #93c5fd', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#2563eb', cursor: 'pointer', fontSize: 16 }}>
                        <FaPhoneAlt />
                      </button>
                    )}
                    {!appt.sessionComments ? (
                      <button
                        onClick={e => { e.stopPropagation(); setSelectedAppt(appt); setSelectedReasons([]); setCommentText(''); setShowCommentModal(true); }}
                        title="Add Comments"
                        style={{ minWidth: 42, height: 42, borderRadius: 10, background: '#fff7ed', border: '1.5px solid #fdba74', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#c2410c', cursor: 'pointer', fontSize: 16 }}>
                        <FaComment />
                      </button>
                    ) : (
                      <span title={`Comment: ${appt.sessionComments}`}
                        style={{ minWidth: 42, height: 42, borderRadius: 10, background: '#f0fdf4', border: '1.5px solid #86efac', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#16a34a', fontSize: 16 }}>
                        <FaComment />
                      </span>
                    )}
                    {appt.patientCard && (
                      <button
                        onClick={e => { e.stopPropagation(); navigate(`/SessionIpadView/${appt.patientCard}`); }}
                        title="Go to Session"
                        style={{ marginLeft: 'auto', padding: '6px 14px', height: 42, borderRadius: 10, background: '#eff6ff', border: '1.5px solid #93c5fd', color: '#1d4ed8', cursor: 'pointer', fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap' }}>
                        Session ›
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>

      {/* ═══ APPOINTMENT DETAIL MODAL ═══ */}
      {detailAppt && (() => {
        const appt = detailAppt;
        const startDate = new Date(appt.start || appt.date);
        const endDate = new Date(appt.end || appt.date);
        const { isUpcoming, isLate, isMissed } = getAppointmentStatusFlags(appt);
        let phone = '';
        if (appt.title && appt.title.includes('/')) phone = appt.title.split('/')[1]?.trim();
        const whatsappTextUrl = phone ? `https://wa.me/91${phone}?text=Hello%2C%20your%20appointment%20is%20due%20soon.` : '';
        const whatsappCallUrl = phone ? `https://wa.me/91${phone}` : '';
        const isScheduledTomorrow = tomappointments.some(t => t.patientCard === appt.patientCard);

        return (
          <div onClick={() => setDetailAppt(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 18, width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.25)', position: 'relative' }}>
              {/* Header */}
              <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid #f1f5f9' }}>
                <button onClick={() => setDetailAppt(null)} style={{ position: 'absolute', top: 14, right: 14, background: '#f1f5f9', border: 'none', borderRadius: 8, width: 32, height: 32, fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>{'\u2715'}</button>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>{(appt.title || '').split('/')[0]}</div>
                {appt.patientCard && <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{appt.patientCard}</div>}
                <div style={{ fontSize: 14, color: '#334155', marginTop: 8, fontWeight: 600 }}>
                  {startDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} — {endDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  <span style={{ marginLeft: 10, fontSize: 12, color: '#94a3b8' }}>{startDate.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}</span>
                </div>
              </div>
              {/* Status banners */}
              <div style={{ padding: '0 24px' }}>
                {isUpcoming && <div style={{ margin: '10px 0', padding: '8px 12px', borderRadius: 8, background: '#fff7ed', color: '#c2410c', fontWeight: 700, fontSize: 13 }}>Upcoming within 1 hour — Call Now!</div>}
                {isLate && <div style={{ margin: '10px 0', padding: '8px 12px', borderRadius: 8, background: '#eff6ff', color: '#1d4ed8', fontWeight: 700, fontSize: 13 }}>Patient running late — Please Call</div>}
                {appt.missedToday && <div style={{ margin: '10px 0', padding: '8px 12px', borderRadius: 8, background: '#fef2f2', color: '#dc2626', fontWeight: 700, fontSize: 13 }}>Missed Today!{appt.missedCount > 0 && ` (${appt.missedCount} consecutive)`}</div>}
                {appt.missedYesterday && !appt.missedToday && <div style={{ margin: '10px 0', padding: '8px 12px', borderRadius: 8, background: '#fef2f2', color: '#dc2626', fontWeight: 700, fontSize: 13 }}>Missed Yesterday{appt.missedCount > 0 && ` (${appt.missedCount} consecutive)`}</div>}
                {isScheduledTomorrow && <div style={{ margin: '10px 0', padding: '8px 12px', borderRadius: 8, background: '#f0fdf4', color: '#16a34a', fontWeight: 700, fontSize: 13 }}>Scheduled for tomorrow</div>}
                {appt.escalated && (
                  <div style={{ margin: '10px 0', padding: '8px 12px', borderRadius: 8, background: '#fef2f2', color: '#dc2626', fontWeight: 700, fontSize: 13, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <span>ESCALATED {appt.escalationDate && new Date(appt.escalationDate).toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })}</span>
                    <button onClick={() => { setSessionCompleteAppt(appt); setShowStandaloneEscalation(true); setDetailAppt(null); }}
                      style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 6, fontSize: 11, fontWeight: 700, padding: '4px 10px', cursor: 'pointer' }}>View</button>
                  </div>
                )}
                {appt.autoMarkedDone && (
                  <div style={{ margin: '10px 0', padding: '8px 12px', borderRadius: 8, background: '#fff7ed', color: '#c2410c', fontWeight: 600, fontSize: 12 }}>
                    Auto-marked at {appt.autoMarkedAt ? new Date(appt.autoMarkedAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' }) : '9:00 PM'} IST
                    {appt.autoMarkedReason && <div style={{ marginTop: 2, opacity: 0.85 }}>{appt.autoMarkedReason}</div>}
                  </div>
                )}
              </div>
              {/* Comments */}
              <div style={{ padding: '12px 24px' }}>
                {appt.sessionComments ? (
                  <div style={{ fontSize: 13, color: '#334155' }}><strong>Comments:</strong> {appt.sessionComments}</div>
                ) : (
                  <button onClick={() => { setSelectedAppt(appt); setSelectedReasons([]); setCommentText(''); setShowCommentModal(true); setDetailAppt(null); }}
                    style={{ background: '#eff6ff', color: '#2563eb', border: '1px solid #bfdbfe', borderRadius: 8, padding: '8px 16px', fontSize: 13, fontWeight: 600, cursor: 'pointer', width: '100%' }}>
                    + Add Comments
                  </button>
                )}
              </div>
              {/* Action buttons */}
              <div style={{ padding: '8px 24px 20px', display: 'flex', flexDirection: 'column', gap: 8 }}>
                <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                  {appt.patientCard && (
                    <button onClick={() => { navigate(`/SessionIpadView/${appt.patientCard}`); setDetailAppt(null); }}
                      style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #dbeafe', background: '#eff6ff', color: '#1d4ed8', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                      Session
                    </button>
                  )}
                  <button onClick={() => { openShowModal(appt, 'patient'); setDetailAppt(null); }}
                    style={{ flex: 1, padding: '9px 12px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#f8fafc', color: '#334155', fontSize: 12, fontWeight: 700, cursor: 'pointer' }}>
                    3 Months
                  </button>
                </div>
                {phone && (
                  <div style={{ display: 'flex', gap: 8 }}>
                    <button onClick={() => { setDetailAppt(null); setCallModal({ appt, phone, mode: 'whatsapp' }); }}
                      style={{ flex: 1, padding: '9px 12px', borderRadius: 8, background: '#dcfce7', color: '#16a34a', fontSize: 12, fontWeight: 700, textAlign: 'center', border: '1px solid #bbf7d0', cursor: 'pointer' }}>
                      WhatsApp
                    </button>
                    <button onClick={() => { setDetailAppt(null); setCallModal({ appt, phone, mode: 'call' }); }}
                      style={{ flex: 1, padding: '9px 12px', borderRadius: 8, background: '#dbeafe', color: '#2563eb', fontSize: 12, fontWeight: 700, textAlign: 'center', border: '1px solid #93c5fd', cursor: 'pointer' }}>
                      Call
                    </button>
                  </div>
                )}
                {!isScheduledTomorrow && (
                  <button onClick={() => { openScheduleModal(appt); setDetailAppt(null); }}
                    style={{ width: '100%', padding: '10px', borderRadius: 8, border: 'none', background: 'linear-gradient(135deg, #7c3aed, #6d28d9)', color: '#fff', fontSize: 13, fontWeight: 700, cursor: 'pointer' }}>
                    Schedule for Tomorrow / Future
                  </button>
                )}
                {isAfter2PMIST() && ['scheduled', 'inprogress'].includes(appt.status?.toLowerCase()) && (
                  <button
                    onClick={() => {
                      const isScheduled = appt.status?.toLowerCase() === 'scheduled';
                      setSessionCompleteAppt(appt);
                      setScLeadTherapist("selectT");
                      setScLeadTherapistDesignation("");
                      setScHelper1("selectT");
                      setScHelper2("selectT");
                      setScComment("");
                      setShowEscalationInComplete(false);
                      setScExerciseBulkStatus('');
                      setScActualEndTime(toDatetimeLocal());
                      setScActualStartTime(isScheduled ? toDatetimeLocal(appt.start || appt.date) : '');
                      fetchTherapistsForModal();
                      fetchPatientExercises(appt.patientCard);
                      setShowSessionCompleteModal(true);
                      setDetailAppt(null);
                    }}
                    style={{
                      width: '100%', padding: '10px', border: 'none', borderRadius: 8,
                      background: appt.status?.toLowerCase() === 'inprogress'
                        ? 'linear-gradient(135deg, #e53935, #b71c1c)'
                        : 'linear-gradient(135deg, #43a047, #1b5e20)',
                      color: '#fff', fontWeight: 800, fontSize: 14, cursor: 'pointer',
                    }}
                  >
                    {appt.status?.toLowerCase() === 'inprogress' ? 'Mark Session Complete' : 'Mark Session Complete'}
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      })()}

      {/* Pending Patient Bookings — visible to admin/superadmin/owner only */}
      {canDo(auth, 'appointments.view') && pendingBookings.length > 0 && (
        <section className="tasks-section" style={{ marginBottom: 16, border: '2px solid #f59e0b', borderRadius: 14 }}>
          <div className={`section-title ${showPendingBookings ? 'open' : ''}`} onClick={() => setShowPendingBookings(v => !v)}
            style={{ background: '#fef3c7', borderRadius: showPendingBookings ? '12px 12px 0 0' : 12, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px' }}>
            <span style={{ fontWeight: 700, color: '#92400e' }}>
              🟡 Pending Patient Bookings
              <span style={{ marginLeft: 8, background: '#f59e0b', color: '#fff', borderRadius: 8, padding: '1px 8px', fontSize: 12 }}>{pendingBookings.length}</span>
            </span>
            <span className="section-chevron">{showPendingBookings ? <FaChevronUp /> : <FaChevronDown />}</span>
          </div>
          {showPendingBookings && pendingBookings.map(bk => (
            <div key={bk._id} style={{ padding: '10px 16px', borderTop: '1px solid #fde68a', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8, background: '#fffbeb' }}>
              <div>
                <div style={{ fontWeight: 700, fontSize: 14 }}>{bk.name || bk.title}</div>
                <div style={{ fontSize: 12, color: '#666' }}>
                  {bk.patientCard && <span>Card: {bk.patientCard} · </span>}
                  {new Date(bk.date).toLocaleDateString()} {bk.start ? new Date(bk.start).toLocaleTimeString([], {hour:'2-digit',minute:'2-digit'}) : ''}
                  {bk.bookingType && <span> · {bk.bookingType}</span>}
                </div>
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={async () => {
                  try {
                    await api.put(`${process.env.REACT_APP_URL}/appointments/patient-bookings/${bk._id}/confirm`);
                    setPendingBookings(prev => prev.filter(b => b._id !== bk._id));
                  } catch (e) { alert('Error confirming booking'); }
                }} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 16px', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}>
                  Confirm
                </button>
                <button onClick={async () => {
                  try {
                    await api.put(`${process.env.REACT_APP_URL}/appointments/patient-bookings/${bk._id}/reject`);
                    setPendingBookings(prev => prev.filter(b => b._id !== bk._id));
                  } catch (e) { alert('Error rejecting booking'); }
                }} style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 16px', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}>
                  Reject
                </button>
              </div>
            </div>
          ))}
        </section>
      )}

      {/* Pending Consultation Approvals */}
      {canDo(auth, 'appointments.view') && pendingApprovals.length > 0 && (
        <section className="tasks-section" style={{ marginBottom: 16, border: '2px solid #a78bfa', borderRadius: 14 }}>
          <div className={`section-title ${showPendingApprovals ? 'open' : ''}`} onClick={() => setShowPendingApprovals(v => !v)}
            style={{ background: '#ede9fe', borderRadius: showPendingApprovals ? '12px 12px 0 0' : 12, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 16px' }}>
            <span style={{ fontWeight: 700, color: '#4c1d95' }}>
              📋 Treatment Plans Awaiting Approval
              <span style={{ marginLeft: 8, background: '#7c3aed', color: '#fff', borderRadius: 8, padding: '1px 8px', fontSize: 12 }}>{pendingApprovals.length}</span>
            </span>
            <span className="section-chevron">{showPendingApprovals ? <FaChevronUp /> : <FaChevronDown />}</span>
          </div>
          {showPendingApprovals && pendingApprovals.map(plan => (
            <div key={plan._id || plan.patientCard} style={{ padding: '10px 16px', borderTop: '1px solid #ddd6fe', background: '#faf5ff' }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap' }}>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: '#1a202c' }}>{plan.patientName}</div>
                  <div style={{ fontSize: 12, color: '#666', marginTop: 2 }}>
                    Card: {plan.patientCard}
                    {plan.therapist && <span> · By: {plan.therapist}</span>}
                    <span> · {plan.sequences} sequences · {plan.recommendations} recommendations</span>
                    <span> · {(plan.mythsessions||0)+(plan.maintsessions||0)+(plan.preventivesessions||0)} sessions</span>
                  </div>
                  {plan.drcomments && (
                    <div style={{ fontSize: 12, color: '#555', marginTop: 4, fontStyle: 'italic', maxWidth: 440 }}>{plan.drcomments}</div>
                  )}
                </div>
                <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                  <button onClick={async () => {
                    try {
                      await api.post(`${process.env.REACT_APP_URL}/patients/consultation/${plan.patientCard}/approve`, { decision: 'approved' });
                      setPendingApprovals(prev => prev.filter(p => p.patientCard !== plan.patientCard));
                    } catch (e) { alert('Error approving plan'); }
                  }} style={{ background: '#16a34a', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 16px', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}>
                    Approve
                  </button>
                  <button onClick={async () => {
                    try {
                      await api.post(`${process.env.REACT_APP_URL}/patients/consultation/${plan.patientCard}/approve`, { decision: 'rejected' });
                      setPendingApprovals(prev => prev.filter(p => p.patientCard !== plan.patientCard));
                    } catch (e) { alert('Error rejecting plan'); }
                  }} style={{ background: '#dc2626', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 16px', fontWeight: 600, cursor: 'pointer', fontSize: 13 }}>
                    Reject
                  </button>
                </div>
              </div>
            </div>
          ))}
        </section>
      )}

      {/* Flow Tasks */}
      {flowTasks.length > 0 && (
        <section className="tasks-section" style={{ marginBottom: 16 }}>
          {/* FMS summary stat cards */}
          <div style={{ display: 'flex', gap: 10, marginBottom: 10, flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: 90, background: 'linear-gradient(135deg, #1e40af, #2563eb)', color: '#fff', borderRadius: 12, padding: '10px 14px', textAlign: 'center', boxShadow: '0 2px 8px rgba(37,99,235,0.18)' }}>
              <div style={{ fontSize: 22, fontWeight: 800, lineHeight: 1 }}>{flowTasks.length}</div>
              <div style={{ fontSize: 11, opacity: 0.85, marginTop: 3 }}>Total</div>
            </div>
            <div style={{ flex: 1, minWidth: 90, background: 'linear-gradient(135deg, #0891b2, #0e7490)', color: '#fff', borderRadius: 12, padding: '10px 14px', textAlign: 'center', boxShadow: '0 2px 8px rgba(8,145,178,0.18)' }}>
              <div style={{ fontSize: 22, fontWeight: 800, lineHeight: 1 }}>{flowTasks.filter(t => t.status === 'in_progress').length}</div>
              <div style={{ fontSize: 11, opacity: 0.85, marginTop: 3 }}>Active</div>
            </div>
            <div style={{ flex: 1, minWidth: 90, background: 'linear-gradient(135deg, #dc2626, #b91c1c)', color: '#fff', borderRadius: 12, padding: '10px 14px', textAlign: 'center', boxShadow: '0 2px 8px rgba(220,38,38,0.18)' }}>
              <div style={{ fontSize: 22, fontWeight: 800, lineHeight: 1 }}>{flowTasks.filter(t => t.deadline && new Date(t.deadline) < new Date() && t.status !== 'completed').length}</div>
              <div style={{ fontSize: 11, opacity: 0.85, marginTop: 3 }}>Overdue</div>
            </div>
            <div style={{ flex: 1, minWidth: 90, background: 'linear-gradient(135deg, #f59e0b, #d97706)', color: '#fff', borderRadius: 12, padding: '10px 14px', textAlign: 'center', boxShadow: '0 2px 8px rgba(245,158,11,0.18)' }}>
              <div style={{ fontSize: 22, fontWeight: 800, lineHeight: 1 }}>{flowTasks.filter(t => t.status === 'pending').length}</div>
              <div style={{ fontSize: 11, opacity: 0.85, marginTop: 3 }}>Pending</div>
            </div>
          </div>

          <div className={`section-title ${showFlowTasks ? 'open' : ''}`} onClick={() => setShowFlowTasks(v => !v)}
            style={{ background: 'linear-gradient(90deg, #1e40af12, #0891b210)', borderRadius: '10px 10px 0 0' }}>
            <span className="section-label">
              ⚡ Flow Tasks
              <span style={{ background: '#2563eb', color: '#fff', borderRadius: 20, padding: '1px 10px', fontSize: 12, fontWeight: 700, marginLeft: 8 }}>
                {flowTasks.filter(t => t.status === 'in_progress').length} active
              </span>
              {flowTasks.length > 0 && (
                <span style={{ background: '#f3f4f6', color: '#374151', borderRadius: 20, padding: '1px 10px', fontSize: 12, fontWeight: 600, marginLeft: 6 }}>
                  {flowTasks.length} total
                </span>
              )}
            </span>
            <span className="section-chevron">{showFlowTasks ? <FaChevronUp /> : <FaChevronDown />}</span>
          </div>

          {showFlowTasks && flowTasks.map((ft, idx) => {
            const isActive = ft.status === 'in_progress';
            const isOverdue = ft.deadline && new Date(ft.deadline) < new Date();
            return (
              <div key={idx} style={{
                background: isOverdue ? '#fff7f7' : isActive ? '#eff6ff' : '#fff',
                border: `1px solid ${isOverdue ? '#fca5a5' : isActive ? '#bfdbfe' : '#e5e7eb'}`,
                borderRadius: 10, padding: '12px 16px', marginBottom: 8,
                borderLeft: `4px solid ${isOverdue ? '#dc2626' : isActive ? '#2563eb' : '#9ca3af'}`,
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 4 }}>
                      <span style={{ fontWeight: 800, fontSize: 14, color: '#1e3a5f' }}>
                        {isActive ? '🔄' : '⏳'} {ft.title}
                      </span>
                      <span style={{ fontSize: 10, background: isActive ? '#dbeafe' : '#f3f4f6', color: isActive ? '#1d4ed8' : '#6b7280', borderRadius: 6, padding: '2px 8px', fontWeight: 700 }}>
                        Step {ft.stepNumber}
                      </span>
                      {isOverdue && <span style={{ fontSize: 11, color: '#dc2626', fontWeight: 800 }}>⚠️ OVERDUE</span>}
                      {ft.requiresApproval && <span style={{ fontSize: 10, background: '#ede9fe', color: '#6d28d9', borderRadius: 6, padding: '2px 7px', fontWeight: 700 }}>🔐 Needs Approval</span>}
                    </div>
                    <div style={{ fontSize: 12, color: '#374151', marginBottom: 4 }}>
                      <strong>Flow:</strong> {ft.flowName}
                    </div>
                    {ft.what && <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 4 }}>📋 {ft.what}</div>}
                    <div style={{ display: 'flex', gap: 12, fontSize: 11, color: '#9ca3af', flexWrap: 'wrap' }}>
                      {ft.ownerName && <span>🏷️ Owner: {ft.ownerName}</span>}
                      {ft.deadline && (
                        <span style={{ color: isOverdue ? '#dc2626' : '#6b7280' }}>
                          📅 Due: {new Date(ft.deadline).toLocaleString('en-IN', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' })}
                        </span>
                      )}
                    </div>
                  </div>
                  {isActive && (
                    <button
                      onClick={async () => {
                        if (!(await showConfirm(`Mark "${ft.title}" as complete?`))) return;
                        try {
                          await api.put(`${process.env.REACT_APP_URL}/flows/${ft.flowId}/steps/${ft.stepId}/complete`, {
                            completedBy: auth.username, completionNotes: '',
                          });
                          fetchDashboardData();
                        } catch (err) {
                          showAlert('Failed to mark step done: ' + (err?.response?.data?.error || err.message), 'error');
                        }
                      }}
                      style={{
                        padding: '8px 18px', background: 'linear-gradient(135deg, #16a34a, #15803d)',
                        color: '#fff', border: 'none', borderRadius: 8, fontWeight: 700, fontSize: 13,
                        cursor: 'pointer', flexShrink: 0,
                      }}
                    >
                      ✓ Mark Done
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </section>
      )}

      {/* Tasks */}
      {tasks.length > 0 && !loading &&
      <section className="tasks-section">
        <div className={`section-title ${showOTT ? 'open' : ''}`} onClick={() => setShowOTT(!showOTT)}>
          <span className="section-label">🗂️ One Time Tasks
            <span style={{ background: '#ff9800', color: '#fff', borderRadius: 20, padding: '1px 10px', fontSize: 12, fontWeight: 700, marginLeft: 8 }}>
              {(tasks.filter(task => task.status !== 'completed')).length}
            </span>
          </span>
          <span className="section-chevron">{showOTT ? <FaChevronUp /> : <FaChevronDown />}</span>
        </div>
        {showOTT && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: 10 }}>
            {tasks.filter(task => task.status !== 'completed').map((task, idx) => {
              const isInProgress = task.status?.toLowerCase() === 'new' || task.status?.toLowerCase() === 'pending';
              const isScheduled = task.status?.toLowerCase() === 'delayed';
              const overdueDays = (() => {
                if (!task.estimatedEndDate || task.status === 'completed') return null;
                const diff = Math.ceil((new Date() - new Date(task.estimatedEndDate)) / 86400000);
                return diff > 0 ? diff : null;
              })();
              let borderColor = isScheduled ? '#ef4444' : isInProgress ? '#f59e0b' : '#e2e8f0';
              let statusColor = isScheduled ? '#dc2626' : isInProgress ? '#92400e' : '#475569';
              let statusBg = isScheduled ? '#fee2e2' : isInProgress ? '#fef3c7' : '#f1f5f9';

              return (
                <div key={task._id || idx} onClick={() => setDetailTask(task)}
                  style={{
                    background: '#fff', borderRadius: 12, padding: '12px 14px', cursor: 'pointer',
                    borderLeft: `4px solid ${borderColor}`, boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
                    transition: 'transform 0.12s, box-shadow 0.12s', position: 'relative',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)'; }}
                  onMouseLeave={e => { e.currentTarget.style.transform = ''; e.currentTarget.style.boxShadow = '0 1px 4px rgba(0,0,0,0.06)'; }}
                >
                  {/* Status chip */}
                  <span style={{ position: 'absolute', top: 8, right: 8, fontSize: 9, fontWeight: 700, color: statusColor, background: statusBg, padding: '2px 7px', borderRadius: 6, textTransform: 'uppercase', letterSpacing: '.3px' }}>
                    {task.status || '—'}
                  </span>
                  {/* Title */}
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 4, paddingRight: 55, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                    {task.title || task.name || 'Untitled Task'}
                  </div>
                  {/* Due date */}
                  <div style={{ fontSize: 12, color: '#64748b', fontWeight: 600, marginBottom: 4 }}>
                    Due: {task.estimatedEndDate ? task.estimatedEndDate.split("T")[0].split("-").reverse().join("-") : "—"}
                  </div>
                  {/* Urgency */}
                  <div style={{ fontSize: 10, color: '#94a3b8', fontWeight: 600 }}>{task.urgentLevel || 'Important'}</div>
                  {/* Anomaly badges + Mark Done */}
                  <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap', marginTop: 6, alignItems: 'center' }}>
                    {overdueDays && <span style={{ fontSize: 9, fontWeight: 700, background: '#fef2f2', color: '#dc2626', padding: '1px 6px', borderRadius: 4 }}>{overdueDays}d overdue</span>}
                    {task.merit?.redStars > 0 && <span style={{ fontSize: 9, fontWeight: 700, background: '#fef2f2', color: '#dc2626', padding: '1px 6px', borderRadius: 4 }}>{'●'.repeat(task.merit.redStars)}</span>}
                    {task.totalWorth > 0 && <span style={{ fontSize: 9, fontWeight: 700, background: '#fffbeb', color: '#d97706', padding: '1px 6px', borderRadius: 4 }}>{'★'.repeat(Number(task.totalWorth))}</span>}
                    <button
                      onClick={async (e) => {
                        e.stopPropagation();
                        if (!(await showConfirm('Mark this task as done?'))) return;
                        const today = new Date().toISOString().split('T')[0];
                        const { redStars, blueStars, updatedStatus } = calculateTaskStars({
                          ...task, finalEndDate: today, status: 'completed'
                        }, new Date());
                        const updatedTask = {
                          ...task, status: updatedStatus, finalEndDate: today,
                          merit: { redStars, blueStars }
                        };
                        try {
                          const res = await api.post(`${process.env.REACT_APP_URL}/tasks/${task._id}`, {
                            task: updatedTask,
                            user: { roles: auth.roles, username: auth.username }
                          });
                          setTasks(tasks.map(t => t._id === task._id ? res.data : t));
                        } catch (err) {
                          console.error('Failed to mark done', err);
                          alert('Error: ' + (err.response?.data?.message || err.message));
                        }
                      }}
                      style={{
                        marginLeft: 'auto', padding: '3px 10px', borderRadius: 6, border: '1px solid #86efac',
                        background: '#dcfce7', color: '#166534', fontSize: 11, fontWeight: 700, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', gap: 3,
                      }}
                    >
                      ✓ Done
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </section>
      }

      {/* ═══ OTT TASK DETAIL MODAL ═══ */}
      {detailTask && (() => {
        const task = detailTask;
        const isInProgress = task.status?.toLowerCase() === 'new' || task.status?.toLowerCase() === 'pending';
        const isScheduled = task.status?.toLowerCase() === 'delayed';
        const overdueDays = (() => {
          if (!task.estimatedEndDate || task.status === 'completed') return null;
          const diff = Math.ceil((new Date() - new Date(task.estimatedEndDate)) / 86400000);
          return diff > 0 ? diff : null;
        })();
        return (
          <div onClick={() => setDetailTask(null)} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
            <div onClick={e => e.stopPropagation()} style={{ background: '#fff', borderRadius: 18, width: '100%', maxWidth: 480, maxHeight: '90vh', overflowY: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.25)', position: 'relative' }}>
              {/* Header */}
              <div style={{ padding: '20px 24px 16px', borderBottom: '1px solid #f1f5f9' }}>
                <button onClick={() => setDetailTask(null)} style={{ position: 'absolute', top: 14, right: 14, background: '#f1f5f9', border: 'none', borderRadius: 8, width: 32, height: 32, fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#64748b' }}>{'\u2715'}</button>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#0f172a' }}>{task.title || task.name || 'Untitled Task'}</div>
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 8, flexWrap: 'wrap' }}>
                  <span style={{
                    background: isScheduled ? '#fee2e2' : isInProgress ? '#fef3c7' : '#f1f5f9',
                    color: isScheduled ? '#dc2626' : isInProgress ? '#92400e' : '#475569',
                    borderRadius: 20, padding: '3px 12px', fontSize: 12, fontWeight: 700
                  }}>
                    {task.status || '—'}
                  </span>
                  <span style={{ fontSize: 12, color: '#64748b', fontWeight: 600 }}>
                    {task.urgentLevel || 'Important'}
                  </span>
                  {task.totalWorth > 0 && (
                    <span style={{ color: '#f59e0b', fontSize: 14 }}>
                      {[...Array(Number(task.totalWorth))].map((_, i) => <FaStar key={i} />)}
                    </span>
                  )}
                </div>
              </div>
              {/* Info */}
              <div style={{ padding: '12px 24px' }}>
                <div style={{ fontSize: 13, color: '#334155', marginBottom: 8 }}>
                  <strong>Due:</strong> {task.estimatedEndDate ? task.estimatedEndDate.split("T")[0].split("-").reverse().join("-") : "—"}
                </div>
                {overdueDays && (
                  <div style={{ margin: '8px 0', padding: '8px 12px', borderRadius: 8, background: '#fef2f2', color: '#dc2626', fontWeight: 700, fontSize: 13 }}>
                    {overdueDays} days overdue
                  </div>
                )}
                {task.merit?.redStars > 0 && (
                  <div style={{ margin: '8px 0', padding: '8px 12px', borderRadius: 8, background: '#fef2f2', color: '#dc2626', fontWeight: 600, fontSize: 13 }}>
                    Red marks: {[...Array(task.merit.redStars)].map((_, i) => <span key={i}>●</span>)}
                  </div>
                )}
                {task.notes && (() => {
                  let parsed = null;
                  try {
                    const p = typeof task.notes === 'string' ? JSON.parse(task.notes) : task.notes;
                    if (p && typeof p === 'object') parsed = p;
                  } catch (e) { /* not JSON, render as text */ }
                  if (parsed) {
                    const entries = Array.isArray(parsed)
                      ? parsed.map((v, i) => [String(i + 1), typeof v === 'object' ? JSON.stringify(v) : String(v)])
                      : Object.entries(parsed).map(([k, v]) => [k, typeof v === 'object' ? JSON.stringify(v) : String(v)]);
                    return (
                      <div style={{ margin: '8px 0', padding: '10px 12px', borderRadius: 8, background: '#f8fafc' }}>
                        <strong style={{ color: '#334155', fontSize: 13 }}>Notes:</strong>
                        <div style={{ marginTop: 6, display: 'flex', flexDirection: 'column', gap: 4 }}>
                          {entries.map(([k, v]) => (
                            <div key={k} style={{ display: 'flex', gap: 8, fontSize: 13, lineHeight: 1.5 }}>
                              <span style={{ color: '#64748b', fontWeight: 600, minWidth: 80, flexShrink: 0 }}>{k}:</span>
                              <span style={{ color: '#334155', wordBreak: 'break-word' }}>{v}</span>
                            </div>
                          ))}
                        </div>
                      </div>
                    );
                  }
                  return (
                    <div style={{ margin: '8px 0', padding: '10px 12px', borderRadius: 8, background: '#f8fafc', color: '#334155', fontSize: 13, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                      <strong>Notes:</strong> {task.notes}
                    </div>
                  );
                })()}
              </div>
              {/* Mark Done */}
              <div style={{ padding: '8px 24px 20px' }}>
                {task.status !== 'completed' && (
                  <button
                    onClick={async () => {
                      if (!(await showConfirm('Are you sure you want to mark this task as done?'))) return;
                      const today = new Date().toISOString().split('T')[0];
                      const { redStars, blueStars, updatedStatus } = calculateTaskStars({
                        ...task, finalEndDate: today, status: 'completed'
                      }, new Date());
                      const updatedTask = {
                        ...task, status: updatedStatus, finalEndDate: today,
                        merit: { redStars, blueStars }
                      };
                      try {
                        const res = await api.post(`${process.env.REACT_APP_URL}/tasks/${task._id}`, {
                          task: updatedTask,
                          user: { roles: auth.roles, username: auth.username }
                        });
                        setTasks(tasks.map(t => t._id === task._id ? res.data : t));
                        setDetailTask(null);
                      } catch (err) {
                        console.error('Failed to mark done', err);
                        alert('Error updating task');
                      }
                    }}
                    style={{
                      width: '100%', padding: '12px', border: 'none', borderRadius: 8,
                      background: 'linear-gradient(135deg, #43a047, #1b5e20)',
                      color: '#fff', fontWeight: 800, fontSize: 14, cursor: 'pointer',
                    }}
                  >
                    ✓ Mark Task Done
                  </button>
                )}
              </div>
            </div>
          </div>
        );
      })()}
      {/* Checklists 
      <section className="tasks-section">
        <h3>🗂️ Checklists</h3>
        {checklists.length === 0 ? (
           <p>No checklists yet.</p>
             ) : (
             checklists.map((item) => {
                const recurrences = item.recurrences || [];
       
               // get month offset for this checklist
               const monthOffset = monthOffsets[item._id] ?? 0;
       
               const now = new Date();
               const displayMonth = new Date(now.getFullYear(), now.getMonth() + monthOffset, 1);
       
               const recurrencesThisMonth = recurrences.filter(({ date }) => {
                 const d = new Date(date);
                 return d.getFullYear() === displayMonth.getFullYear() && d.getMonth() === displayMonth.getMonth();
               });
       
               return (
                 <div
                   key={item._id}
                   style={{
                     border: "1px solid #ddd",
                     borderRadius: "8px",
                     padding: 15,
                     marginBottom: 20,
                     background: "#fff",
                   }}
                 >
                   <div
                     style={{
                       display: "flex",
                       justifyContent: "space-between",
                       alignItems: "center",
                     }}
                   >
                     <h3 style={{ margin: 0 }}>{item.title}</h3>
       
                     <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                       
                       <span onClick={() => changeMonth(item._id, -1)} style={{ cursor: "pointer", fontSize: "22px", marginRight: 8 }}>
                         &lt;
                       </span>
                       <span style={{ minWidth: "110px", textAlign: "center", fontWeight: 500 }}>
                         {displayMonth.toLocaleString("default", { month: "long", year: "numeric" })}
                       </span>
                       <span onClick={() => changeMonth(item._id, +1)} style={{ cursor: "pointer", fontSize: "22px", marginRight: 70 }}>
                         &gt;
                       </span>
       
                     
                     </div>
                   </div>
       
                   <p>{item.description}</p>
                   <p>                     
                     <strong>:</strong> {item.frequency}
                   </p>
                   {item.startDate && (
                     <p>
                       <strong>Start:</strong>{" "}
                       {new Date(item.startDate).toLocaleDateString()}
                     </p>
                   )}
       
                   
                   <div
                     style={{
                       display: "flex",
                       flexWrap: "wrap",
                       gap: "6px",
                       justifyContent: "flex-start",
                       maxWidth: "100%",
                       overflowX: "auto",
                       padding: "8px 0",
                     }}
                   >
                     {recurrencesThisMonth.length > 0 ? (
                       <div
                         style={{
                           display: "flex",
                           flexWrap: "wrap",
                           gap: "4px",
                           justifyContent: "flex-start",
                           overflowX: "auto",
                         }}
                       >
                         {recurrencesThisMonth.map(({ date: dateStr, label }, idx) => {
                           const date = new Date(dateStr);
                           const now = new Date();

                           const completion = item.completions?.find(
                             (c) => new Date(c.date).toDateString() === date.toDateString()
                           );

                           const isCompleted = !!completion;

                           const todayStart = new Date();
                           todayStart.setHours(0, 0, 0, 0);
                           const todayEnd = new Date();
                           todayEnd.setHours(23, 59, 59, 999);

                           const isLate =
                             completion?.isLate || (date < todayStart && !isCompleted);
                           const isFuture = date > todayEnd;

                           const d = new Date(date);
                           d.setHours(0, 0, 0, 0);

                           const isToday = d.getTime() === todayStart.getTime();       
       
                           const formattedDate = date
                             .toLocaleDateString("en-GB", {
                               day: "2-digit",
                               month: "2-digit",
                               year: "2-digit",
                             })
                             .replace(/\//g, "-");
       
                           return (
                             <div
                               key={idx}
                               style={{
                                 flex: "0 1 calc(12.5% - 4px)",
                                 maxWidth: "90px",
                                 minWidth: "70px",
                                 textAlign: "center",
                                 border: "1px solid #bbb",
                                 borderRadius: "6px",
                                 padding: "2px 1px",
                                 background: isCompleted
                                   ? "#e8f5e9"
                                   : isLate
                                   ? "#fdecea"
                                   : isToday
                                   ? "#e3f2fd"
                                   : "#fafafa",
                                 color: isToday ? "#0d47a1" : "inherit",
                                 fontWeight: isToday ? "bold" : "normal",
                                 fontSize: "12px",
                                 lineHeight: 1.2,
                                 boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                               }}
                             >
                               <div style={{ marginBottom: "2px" }}>{formattedDate}</div>
                               {isLate && (
                                 <span
                                   style={{ color: "red", fontSize: "11px", lineHeight: 1 }}
                                 >
                                   ★
                                 </span>
                               )}
                               <div style={{ marginTop: "2px" }}>
                                 <input
                                   type="checkbox"
                                   style={{ height: "20px", width: "20px", cursor: isFuture || isLate || isCompleted ? "not-allowed" : "pointer" }}
                                   checked={isCompleted}
                                   disabled={isFuture || isLate || isCompleted}
                                   onChange={(e) =>
                                     handleRecurrenceTick(item, date, e.target.checked)
                                   }
                                 />
                               </div>
                             </div>
                           );
                         })}
                       </div>
                     ) : (
                       <p style={{ color: "#888" }}>No recurrences for this month</p>
                     )}
                   </div>
       
                 </div>
               );
             })
           )}
      </section>
      */}

      {/* Checklists */}
          {/* Today's Recurrences */}
      <section className="tasks-section">
        <div className={`section-title ${showCheck ? 'open' : ''}`} onClick={() => setShowCheck(!showCheck)}>
          <span className="section-label" style={{ '--accent': '#4caf50' }}>☑️ Checklists (Today)
            <span style={{ background: '#4caf50', color: '#fff', borderRadius: 20, padding: '1px 10px', fontSize: 12, fontWeight: 700, marginLeft: 8 }}>
              {checklists.length}
            </span>
            {missedChecklists.length > 0 && (
              <span style={{ background: '#ef4444', color: '#fff', borderRadius: 20, padding: '1px 10px', fontSize: 12, fontWeight: 700, marginLeft: 4 }}>
                {missedChecklists.length} missed
              </span>
            )}
          </span>
          <span className="section-chevron">{showCheck ? <FaChevronUp /> : <FaChevronDown />}</span>
        </div>

        {showCheck && checklists
          .map((item) => (
            <div
              key={item.id}
              className={`checklist-item${item.isNA ? '' : item.isCompleted ? ' completed' : item.isDelayed ? ' delayed' : ''}`}
              style={item.isCompleted
                ? { background: 'linear-gradient(135deg,#dcfce7,#bbf7d0)', border: '2.5px solid #22c55e', borderRadius: 14, padding: '16px 18px', boxShadow: '0 4px 12px rgba(34,197,94,0.25)', opacity: 1, borderLeft: '6px solid #16a34a', transition: 'all 0.3s ease' }
                : item.isNA ? { opacity: 0.6, background: '#f5f5f5' } : {}}
            >
              <div style={{ flex: 1 }}>
                <div className="cl-title" style={item.isCompleted ? { color: '#15803d', fontWeight: 800, fontSize: '1.05em' } : {}}>
                  {item.isCompleted && <span style={{ marginRight: 8, fontSize: 22 }}>{'\u2705'}</span>}
                  {item.title}
                  {item.isNA && <span style={{ color: '#9e9e9e', fontSize: 11, marginLeft: 6 }}>(N/A)</span>}
                  {item.isCompleted && <span style={{ color: '#fff', fontSize: 12, marginLeft: 8, fontWeight: 700, background: '#16a34a', padding: '3px 12px', borderRadius: 8 }}>Completed</span>}
                </div>
                {item.description && <div className="cl-desc" style={item.isCompleted ? { color: '#15803d' } : {}}>{item.description}</div>}
              </div>
              {!item.isCompleted && !item.isNA && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0 }}>
                {/* Green tick — mark completed */}
                <button
                  onClick={() => item.canComplete && !clBusy[item.id] && handleRecurrenceTick(item, item.recurrenceDate, true)}
                  disabled={!item.canComplete || clBusy[item.id]}
                  style={{
                    width: 36, height: 36, borderRadius: 8, border: 'none',
                    cursor: (!item.canComplete || clBusy[item.id]) ? 'default' : 'pointer',
                    background: clBusy[item.id] ? '#d1d5db' : '#f0fdf4',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 18, fontWeight: 800, transition: 'all 0.15s',
                    color: clBusy[item.id] ? '#9ca3af' : '#86efac',
                    boxShadow: '0 0 0 1.5px #bbf7d0',
                    opacity: clBusy[item.id] ? 0.5 : 1,
                  }}
                  title={clBusy[item.id] ? "Saving..." : "Mark Completed"}
                >{clBusy[item.id] ? '...' : '\u2713'}</button>
                {/* Hyphen — mark N/A */}
                <button
                  onClick={() => !clBusy[item.id] && item.canComplete && handleNotApplicable(item, item.recurrenceDate)}
                  disabled={!item.canComplete || clBusy[item.id]}
                  style={{
                    width: 36, height: 36, borderRadius: 8, border: 'none',
                    cursor: (!item.canComplete || clBusy[item.id]) ? 'default' : 'pointer',
                    background: '#f8fafc',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 20, fontWeight: 900, transition: 'all 0.15s',
                    color: '#94a3b8',
                    boxShadow: '0 0 0 1.5px #cbd5e1',
                  }}
                  title="Not Applicable"
                >{'\u2014'}</button>
              </div>
              )}
            </div>
          ))}

        {/* Missed recurrences (last 7 days) */}
        {showCheck && missedChecklists.length > 0 && (() => {
          const filtered = missedChecklists.filter(m =>
            !missedCLSearch || m.title.toLowerCase().includes(missedCLSearch.toLowerCase())
          );
          // Group by date
          const grouped = {};
          filtered.forEach(m => {
            const key = m.missedDate.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' });
            if (!grouped[key]) grouped[key] = [];
            grouped[key].push(m);
          });
          return (
            <div style={{ marginTop: 8, padding: '8px 10px', background: '#fef2f2', borderRadius: 8, border: '1px solid #fecaca' }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                <span style={{ fontWeight: 700, color: '#991b1b', fontSize: 13 }}>Missed (last 7 days) — {filtered.length}</span>
                <input
                  type="text" placeholder="Search..." value={missedCLSearch}
                  onChange={e => setMissedCLSearch(e.target.value)}
                  style={{ fontSize: 12, padding: '3px 8px', borderRadius: 6, border: '1px solid #fca5a5',
                    outline: 'none', width: 120, background: '#fff' }}
                />
              </div>
              {Object.entries(grouped).map(([dateLabel, items]) => (
                <div key={dateLabel} style={{ marginBottom: 6 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: '#b91c1c', borderBottom: '1px solid #fecaca',
                    padding: '2px 0', marginBottom: 2 }}>{dateLabel}</div>
                  {items.map((m, idx) => (
                    <div key={idx} style={{ fontSize: 12, color: '#7f1d1d', padding: '2px 0 2px 8px', display: 'flex', justifyContent: 'space-between' }}>
                      <span>★ {m.title}</span>
                      <span style={{ color: '#b91c1c', fontWeight: 600, fontSize: 11 }}>{m.daysAgo}d ago</span>
                    </div>
                  ))}
                </div>
              ))}
              {filtered.length === 0 && <div style={{ fontSize: 12, color: '#999', padding: 4 }}>No matches</div>}
            </div>
          );
        })()}
      </section>


    </div>

     {/* Right Column: Tomorrow Scheduling Panel */}
        <div
          className="tomorrow-panel"
          style={{
            flex: "0 0 28%",
            maxWidth: "22vw",
            maxHeight: "85vh",
            overflowY: "auto",
            padding: "14px 12px",
            position: "sticky",
            marginLeft: '2vw',
            top: "15px",
            alignSelf: "flex-start",
          }}
        >
       <h4
          style={{ textAlign: "center", margin: "4px 0 14px", color: "#ff8c00", fontWeight: 700, fontSize: 15, letterSpacing: -0.2, cursor: "pointer" }}
          onClick={() => {
            // Your click logic here
            openShowModal(null, "therapist")
          }}
        >  📅 3 Months Schedule </h4>

          <br/>
          <br/>

          {summary.escalated > 0 && canDo(auth, 'patients.escalate') && (
            <div className="nav-pill" onClick={() => setShowAppt(true)}
              style={{ background: 'linear-gradient(135deg,#dc2626,#b91c1c)', cursor: 'pointer', border: '2px solid #f87171' }}>
              🔔 <span style={{ flex: 1 }}>Escalated</span>
              <span style={{ background: 'rgba(255,255,255,.25)', borderRadius: 20, padding: '1px 8px', fontSize: 12, fontWeight: 800 }}>{summary.escalated}</span>
            </div>
          )}

          {canDo(auth, 'appointments.view') && pendingBookings.length > 0 && (
            <div className="nav-pill" onClick={() => setShowPendingBookings(v => !v)}
              style={{ background: 'linear-gradient(135deg,#d97706,#92400e)', cursor: 'pointer', border: '1px solid #f59e0b' }}>
              🟡 <span style={{ flex: 1 }}>Pending Bookings</span>
              <span style={{ background: 'rgba(255,255,255,.22)', borderRadius: 20, padding: '1px 8px', fontSize: 12, fontWeight: 800 }}>{pendingBookings.length}</span>
            </div>
          )}

          {/* Issued Items moved to summary cards grid in left column */}

          {tasks.length > 0 && (
            <div className="nav-pill" onClick={() => {
              setShowCheck(false); setShowAppt(false); setShowOTT(true);            }} style={{ background: 'linear-gradient(135deg,#e65100,#bf360c)', cursor: "pointer" }}>
              🗂️ <span style={{ flex: 1 }}>One Time Tasks</span>
              <span style={{ background: 'rgba(255,255,255,.22)', borderRadius: 20, padding: '1px 8px', fontSize: 12, fontWeight: 800 }}>
                {tasks.filter(t => t.estimatedEndDate && t.status !== 'completed').length}
              </span>
            </div>
          )}

          {checklists.length > 0 && (
            <div className="nav-pill" onClick={() => {
              setShowCheck(true); setShowAppt(false); setShowOTT(false);            }} style={{ background: 'linear-gradient(135deg,#2e7d32,#1b5e20)', cursor: "pointer" }}>
              ☑️ <span style={{ flex: 1 }}>Checklists</span>
              <span style={{ background: 'rgba(255,255,255,.22)', borderRadius: 20, padding: '1px 8px', fontSize: 12, fontWeight: 800 }}>{checklists.length}</span>
            </div>
          )}

          {summary.redMarks > 0 && (
            <div className="nav-pill" style={{ background: 'linear-gradient(135deg,#b71c1c,#7f0000)' }}>
              ❌ <span>Red Marks</span>
              <span style={{ background: 'rgba(255,255,255,.22)', borderRadius: 20, padding: '1px 8px', fontSize: 12, fontWeight: 800, marginLeft: 'auto' }}>{summary.redMarks}</span>
            </div>
          )} {summary.greenStars > 0 && (
            <div className="nav-pill" style={{ background: 'linear-gradient(135deg,#388e3c,#1b5e20)' }}>
              ✅ <span>Green Stars</span>
              <span style={{ background: 'rgba(255,255,255,.22)', borderRadius: 20, padding: '1px 8px', fontSize: 12, fontWeight: 800, marginLeft: 'auto' }}>{summary.greenStars}</span>
            </div>
          )} {summary.reviewsCollected > 0 && (
            <div className="nav-pill" style={{ background: 'linear-gradient(135deg,#6a1b9a,#4a148c)' }}>
              ⭐ <span>Reviews</span>
              <span style={{ background: 'rgba(255,255,255,.22)', borderRadius: 20, padding: '1px 8px', fontSize: 12, fontWeight: 800, marginLeft: 'auto' }}>{summary.reviewsCollected}</span>
            </div>
          )}


          
          <br/>
          <br/>

        {canDo(auth, 'inventory.view') && (
          <><h4
          style={{ textAlign: "center", margin: "6px 0 10px", color:  "#692802ff", cursor: "pointer" }}
          onClick={() => {
            // Your click logic here
            setShowInventoryModal(true)
          }}
        >  ⚠️ Inventory Shortage </h4>

          <br/>
          <br/>
        </>)}
          <h4 style={{ textAlign: "center", margin: "6px 0 10px", color: "#007bff" }}>
            🧍‍♂️ Saadhak for Tomorrow
          </h4>

          {tomappointments.length === 0 ? (
            <p style={{ textAlign: "center", color: "#888", fontSize: "13px" }}>
              No appointments tomorrow.
            </p>
          ) : (
            tomappointments.map((appt) => {
              const patientName = appt.title.split("/")[0];
              const phone = appt.title.split("/")[1]?.trim() || "";
              const formatted = new Date(appt.start).toLocaleTimeString("en-US", {
                    hour: "2-digit",
                    minute: "2-digit",
                    hour12: true,
                  });
                            
              return (
                <div key={appt._id} className="tomorrow-appt-pill">
                  <strong>{patientName}</strong>
                  <small>{phone && `${phone} · `}{formatted}</small>
                </div>
              );
            })
          )}

            
        </div>
        </div>

      {/* Scheduling Modal */}
      {showScheduleModal && selectedAppt && (
       <div className="modal-overlay">
        <div className="modal-content">
          <h4>Schedule </h4> 
          {selectedAppt.title.split("/")[0]}
          
          {/* Online / Offline toggle */}
          <div style={{ marginTop: 12, display: 'flex', gap: 0, borderRadius: 8, overflow: 'hidden', border: '1px solid #d1d5db', width: 'fit-content' }}>
            <button
              onClick={() => setIsOnlineSchedule(false)}
              style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer', background: !isOnlineSchedule ? '#2563eb' : '#f9fafb', color: !isOnlineSchedule ? '#fff' : '#374151' }}
            >
              At Centre
            </button>
            <button
              onClick={() => setIsOnlineSchedule(true)}
              style={{ padding: '6px 14px', fontSize: 12, fontWeight: 600, border: 'none', cursor: 'pointer', background: isOnlineSchedule ? '#059669' : '#f9fafb', color: isOnlineSchedule ? '#fff' : '#374151' }}
            >
              Online
            </button>
          </div>

          <div style={{ marginTop: '10px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <button onClick={() => scheduleAppointment(selectedAppt, new Date(new Date(selectedAppt.start || selectedAppt.date).setDate(new Date(selectedAppt.start || selectedAppt.date).getDate() + 1)))}>
              Tomorrow
            </button>
            <button onClick={() => setShowDatePicker(true)}>Future</button>
          </div>

          {showDatePicker && (
            <div style={{ marginTop: '15px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <DatePicker
                selected={futureDate}
                onChange={date => setFutureDate(date)}
                showTimeSelect
                timeIntervals={30}
                timeCaption="Time"
                dateFormat="Pp"
                minDate={new Date()}
                inline
              />
              <button onClick={() => scheduleAppointment(selectedAppt, futureDate)}>Schedule</button>
              <button onClick={closeModal}>Cancel</button>
            </div>
          )}
        </div>
      </div>

      )}

      {showAllAppts && selectedAppt && (
        <div className="modal-overlay">
        <div className="modal-content">
          <h4>  🧍‍♂️ 3 months Appointments for : </h4>
          <button onClick={closeShowModal}>Close</button>

          {/* Mini Calendar With Daily Agenda — includes Flow Task deadlines */}
          <MiniCalendarWithBlocks appointments={[
            ...allappointments,
            ...flowTasks.filter(ft => ft.deadline).map(ft => ({
              _id: ft.stepId,
              title: `⚡ ${ft.title} (${ft.flowName})`,
              start: ft.deadline,
              end: ft.deadline,
              type: 'FlowTask',
              status: ft.status,
            })),
            ...tasks.filter(t => t.status !== 'completed' && (t.estimatedEndDate || t.createdAt)).map(t => ({
              _id: t._id,
              title: `🗂️ ${t.title || 'Task'}`,
              start: t.estimatedEndDate || t.createdAt,
              end: t.estimatedEndDate || t.createdAt,
              type: 'Task',
              status: t.status,
            })),
          ]} />
        </div>
        </div>
      )}

      {showAllAppts && (
        <div className="modal-overlay">
        <div className="modal-content">
          <h4>  🧍‍♂️ 3 months Appointments : </h4>
          <button onClick={closeShowModal}>Close</button>

           {/* Mini Calendar With Daily Agenda — includes Flow Task deadlines */}
             <MiniCalendarWithBlocks appointments={[
              ...allappointments,
              ...flowTasks.filter(ft => ft.deadline).map(ft => ({
                _id: ft.stepId,
                title: `⚡ ${ft.title} (${ft.flowName})`,
                start: ft.deadline,
                end: ft.deadline,
                type: 'FlowTask',
                status: ft.status,
              })),
            ]} />
        </div>
        </div>
      )}

      {showInvModal && (
        <div className="modal-overlay">
        <div className="modal-content">
          <h4> Inventory shortage </h4>
          <button onClick={() => setShowInventoryModal(false)}>Close</button>
            
            {inventoryShortage.length === 0 ? (
            <p style={{ textAlign: "center", color: "#888", fontSize: "13px" }}>
              Inventory looks Good !
            </p>
          ) : (
            inventoryShortage.map((inv) => {             
                    const { _id, name, hsn, qtyInStock, issued } = inv;

                    return (
                      <div
                        key={_id}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr auto",
                          alignItems: "center",
                          gap: "10px",
                          padding: "8px 0",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        <div>
                          <strong>{name}</strong> <br />
                          HSN: {hsn} <br />
                          <div
                            style={{ color: "#007bff", cursor: "pointer", marginTop: "4px" }}
                            onClick={() => handlePlaceOrderClick(_id)}
                          >
                            Place Order
                          </div>

                          {extendedForms[_id] && (
                            <div
                              style={{
                                marginTop: "8px",
                                padding: "8px",
                                border: "1px solid #ddd",
                                borderRadius: "6px",
                                background: "#f9f9f9",
                              }}
                            >
                              {!reorderFields[_id] ? (
                                <>
                                  <button
                                    style={{ marginRight: "8px" }}
                                    onClick={() => handleReceivedSupply(_id, name)}
                                  >
                                    Received Supply?
                                  </button>
                                  <button onClick={() => handleReorder(_id)}>ReOrder</button>
                                </>
                              ) : (
                                <>
                                  <div style={{ marginBottom: "8px" }}>
                                    <label>
                                      Qty:{" "}
                                      <input
                                        type="number"
                                        value={reorderQtys[_id] || ""}
                                        onChange={(e) => handleQtyChange(_id, e.target.value)}
                                      />
                                    </label>
                                  </div>
                                  <div style={{ marginBottom: "8px" }}>
                                    Tentative Receiving Date: <strong>{tentativeDates[_id]}</strong>
                                  </div>
                                  <button onClick={() => handleSubmitReorder(_id, name)}>
                                    Submit ReOrder
                                  </button>
                                </>
                              )}
                            </div>
                          )}
                        </div>

                        <div style={{ textAlign: "right" }}>
                          InStock: {qtyInStock} <br />
                          {issued > 0 && <>Issued: {issued}</>}
                        </div>
                      </div>
                    )
                  })                
              )}             
        </div>
        </div>
      )}

      {showIssuedModal && (
        <div className="modal-overlay">
        <div className="modal-content">
          <h4> Issued Items </h4>
          <button onClick={() => setShowIssuedModal(false)}>Close</button>
            
            {issued.length === 0 ? (
            <p style={{ textAlign: "center", color: "#888", fontSize: "13px" }}>
              Nothing issued !
            </p>
          ) : (
            issued.map((inv) => {             
                    const { _id, name, hsn, issued } = inv.service;

                    return (
                      <div
                        key={_id}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr auto",
                          alignItems: "center",
                          gap: "10px",
                          padding: "8px 0",
                          borderBottom: "1px solid #eee",
                        }}
                      >
                        <div>
                          <strong>{name}</strong> : {hsn} <br/>
                        </div>
                      </div>
                    )
                  })                
              )}             
        </div>
        </div>
      )}

      {showSessionCompleteModal && sessionCompleteAppt && (
        <div className="modal-overlay" style={{ zIndex: 99999 }}>
          <div className="modal-content" style={{ maxWidth: 580 }}>
            <button className="close-btn" onClick={() => { setShowSessionCompleteModal(false); setShowEscalationInComplete(false); }}>✕</button>
            <h4 style={{ marginTop: 0 }}>✅ Mark Session Complete</h4>
            <p style={{ color: "#555", fontSize: 14, marginBottom: 14 }}>
              <strong>Patient:</strong> {sessionCompleteAppt.title?.split('/')[0]}
            </p>

            <div className="modal-form-grid" style={{ gap: 12 }}>
              <div className="modal-form-field" style={{ flex: "1 1 100%" }}>
                <label>Lead Therapist (required)</label>
                <select
                  value={scLeadTherapist}
                  onChange={e => {
                    const t = scTherapists.find(x => x.username === e.target.value);
                    setScLeadTherapist(e.target.value);
                    setScLeadTherapistDesignation(t?.designation || "");
                  }}
                >
                  <option value="selectT">-- Select Lead Therapist --</option>
                  {scTherapists.map(t => (
                    <option key={t.username} value={t.username}>{t.username}</option>
                  ))}
                </select>
              </div>

              <div className="modal-form-field">
                <label>Therapist 1 (optional)</label>
                <select value={scHelper1} onChange={e => setScHelper1(e.target.value)}>
                  <option value="selectT">-- None --</option>
                  {scTherapists.map(t => (
                    <option key={t.username} value={t.username}>{t.username}</option>
                  ))}
                </select>
              </div>

              <div className="modal-form-field">
                <label>Therapist 2 (optional)</label>
                <select value={scHelper2} onChange={e => setScHelper2(e.target.value)}>
                  <option value="selectT">-- None --</option>
                  {scTherapists.map(t => (
                    <option key={t.username} value={t.username}>{t.username}</option>
                  ))}
                </select>
              </div>

              {/* Actual time fields */}
              {sessionCompleteAppt?.status?.toLowerCase() === 'scheduled' && (
                <div className="modal-form-field">
                  <label>Actual Start Time</label>
                  <input
                    type="datetime-local"
                    value={scActualStartTime}
                    onChange={e => setScActualStartTime(e.target.value)}
                  />
                </div>
              )}
              <div className="modal-form-field">
                <label>Actual End Time</label>
                <input
                  type="datetime-local"
                  value={scActualEndTime}
                  onChange={e => setScActualEndTime(e.target.value)}
                />
              </div>

              {/* Bulk exercise status */}
              {scPatientExercises.length > 0 && (
                <div className="modal-form-field" style={{ flex: "1 1 100%" }}>
                  <label>Mark remaining exercises as:</label>
                  <div style={{ display: 'flex', gap: 8, marginTop: 4, flexWrap: 'wrap' }}>
                    {['Skipped', 'Completed'].map(s => (
                      <button
                        key={s}
                        type="button"
                        onClick={() => setScExerciseBulkStatus(v => v === s ? '' : s)}
                        style={{
                          padding: '5px 14px', borderRadius: 6, border: '2px solid',
                          borderColor: scExerciseBulkStatus === s ? (s === 'Skipped' ? '#f59e0b' : '#22c55e') : '#ccc',
                          background: scExerciseBulkStatus === s ? (s === 'Skipped' ? '#fff8e1' : '#f0fdf4') : '#f5f5f5',
                          fontWeight: scExerciseBulkStatus === s ? 700 : 400,
                          cursor: 'pointer'
                        }}
                      >
                        {s === 'Skipped' ? '⏭ Skip All Remaining' : '✅ Complete All Remaining'}
                      </button>
                    ))}
                  </div>
                </div>
              )}

              <div className="modal-form-field" style={{ flex: "1 1 100%" }}>
                <label>Session Comment</label>
                <textarea
                  rows={3}
                  placeholder="How was the session?"
                  value={scComment}
                  onChange={e => setScComment(e.target.value)}
                />
              </div>
            </div>

            <label style={{ display: "flex", alignItems: "center", gap: 8, marginTop: 14, cursor: "pointer", fontSize: 14, fontWeight: 600, color: "#f44336" }}>
              <input
                type="checkbox"
                checked={showEscalationInComplete}
                onChange={e => setShowEscalationInComplete(e.target.checked)}
                style={{ width: 16, height: 16 }}
              />
              🚨 Escalate this session?
            </label>

            {showEscalationInComplete && sessionCompleteAppt.patientCard && (
              <EscalationModal
                appointment={sessionCompleteAppt}
                patientCard={sessionCompleteAppt.patientCard}
                onClose={() => setShowEscalationInComplete(false)}
                refreshSequences={fetchDashboardData}
                variant="embedded"
              />
            )}

            <div className="modal-actions" style={{ marginTop: 20 }}>
              <button className="modal-btn-cancel" onClick={() => { setShowSessionCompleteModal(false); setShowEscalationInComplete(false); }}>
                Cancel
              </button>
              <button
                style={{ background: "linear-gradient(135deg,#ff9800,#e65100)" }}
                onClick={() => handleSessionComplete('Skipped')}
              >
                ⏭ Mark Skipped
              </button>
              <button
                style={{ background: "linear-gradient(135deg,#4caf50,#1b5e20)" }}
                onClick={() => handleSessionComplete('Completed')}
              >
                ✅ Mark Completed
              </button>
            </div>
          </div>
        </div>
      )}

      {showCommentModal && selectedAppt && (
        <div className="modal-overlay">
          <div
              style={{
                background: "#fff",
                padding: "16px",
                width: "360px",
                borderRadius: "8px",
              }}
            >

            <h3>📝 Add Session Comments</h3>

            {[
              "Not feeling well",
              "Had to go somewhere",
              "Didn't feel like coming",
              "Someone came over",
              "Other",
            ].map((reason) => (
              <label key={reason} style={{ display: "block", marginBottom: 6 }}>
                <input
                  type="checkbox"
                  checked={selectedReasons.includes(reason)}
                  onChange={(e) => {
                    let updated;
                    if (e.target.checked) {
                      updated = [...selectedReasons, reason];
                    } else {
                      updated = selectedReasons.filter(r => r !== reason);
                    }
                    setSelectedReasons(updated);

                    // auto-fill textarea except "Other"
                    const autoText = updated
                      .filter(r => r !== "Other")
                      .join(", ");

                    if (!updated.includes("Other")) {
                      setCommentText(autoText);
                    }
                  }}
                />
                {" "}{reason}
              </label>
            ))}

            <textarea
              rows={4}
              placeholder="Comments"
              value={commentText}
              onChange={(e) => setCommentText(e.target.value)}
              style={{ width: "100%", marginTop: 10 }}
            />

            <div style={{ marginTop: 12, textAlign: "right" }}>
              <button
                onClick={() => setShowCommentModal(false)}
                style={{ marginRight: 8 }}
              >
                Cancel
              </button>

              <button
                onClick={async () => {
                  if (
                    selectedReasons.includes("Other") &&
                    commentText.trim().length === 0
                  ) {
                    alert("Please enter comments for 'Other'");
                    return;
                  }

                  // 🔹 TODO: API call here if needed
                  // await saveSessionComment(selectedAppt._id, commentText);
                  selectedAppt.sessionComments = commentText.trim();
                  api.post(`${process.env.REACT_APP_URL}/appointments/update/${selectedAppt._id}`, selectedAppt)
                    .then(response => {
                        console.log(response.data);
                        alert("Added Comment");
                    })
                    setShowCommentModal(false);
                }}
                style={{ background: "#4caf50", color: "#fff" }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Standalone Escalation Modal — opened from appointment card "View / Ack" button */}
      {showStandaloneEscalation && sessionCompleteAppt?.patientCard && (
        <EscalationModal
          appointment={sessionCompleteAppt}
          patientCard={sessionCompleteAppt.patientCard}
          onClose={() => setShowStandaloneEscalation(false)}
          refreshSequences={fetchDashboardData}
          variant="modal"
        />
      )}
      {/* Call/WhatsApp Record Modal */}
      {callModal && (
        <AppointmentCallModal
          appointment={callModal.appt}
          phone={callModal.phone}
          mode={callModal.mode}
          onClose={() => setCallModal(null)}
          onSaved={() => { setCallModal(null); fetchDashboardData(); }}
          onSchedule={(appt) => { setCallModal(null); openScheduleModal(appt); }}
        />
      )}
    </div>
  );
};

export default TherapistDashboard;
